/* eslint-disable */
// Bundled legal HTML per locale (edit this file when updating the terms).
import type {AppLocale} from 'i18n/locales'

export const termsLegalBodyByLocale: Record<AppLocale, string> = {
  bg: `<div >
                <p class="meta">Последна актуализация: 05.04.2026</p>

                <div class="intro">
                  Настоящите Общи условия („Условията") уреждат цялото
                  използване на платформата Eventa.tv от организатори, участници
                  и посетители. С достъпването и/или използването на платформата
                  — включително създаване на профил, публикуване или посещение
                  на събитие, покупка на билет или продукт — Вие изрично
                  приемате Условията и всички свързани политики.
                </div>

                
                <h3>1) Кои сме ние</h3>
                <p>
                  Платформата Eventa.tv се управлява от <b>АТОМИКА ГРУП ЕООД</b>
                  , ЕИК <b>205822763</b>, регистрирана по ЗДДС:
                  <b>BG205822763</b>, седалище и адрес на управление: България,
                  гр. Велико Търново, ул. „Никола Габровски" 63-б. Правна форма:
                  ЕООД (по-долу „Eventa.tv", „Платформата", „ние", „нас").
                </p>

                
                <h3>2) Приемане на условията</h3>
                <p>
                  С достъп или използване на Eventa.tv Вие потвърждавате, че сте
                  навършили 18 години (или действате с надлежно съгласие на
                  законен представител), имате право да сключите обвързващ
                  договор и приемате настоящите Условия, Политиката за
                  поверителност и Политиката за бисквитки. Ако не сте съгласни,
                  моля, не използвайте Платформата.
                </p>

                
                <h3>3) Определения</h3>
                <ul>
                  <li>
                    <b>„Платформа" / „Eventa.tv"</b> — уебсайтът, API, мобилните
                    интерфейси и системите на АТОМИКА ГРУП ЕООД за организиране
                    и управление на онлайн и хибридни събития.
                  </li>
                  <li>
                    <b>„Организатор"</b> — физическо или юридическо лице, което
                    създава, публикува и управлява събития чрез Платформата.
                  </li>
                  <li>
                    <b>„Участник"</b> — лице, което се регистрира, закупува
                    билет и/или продукт и/или посещава събитие чрез Платформата.
                  </li>
                  <li>
                    <b>„Събитие"</b> — онлайн или хибридно събитие (конференция,
                    уебинар, курс и др.), публикувано от Организатор, провеждано
                    чрез RTMP стрийминг, Zoom, или друга одобрена интеграция.
                  </li>
                  <li>
                    <b>„Билет"</b> — лично и непрехвърляемо право на достъп до
                    конкретно събитие и/или до Частната страница, при описаните
                    условия и ограничения.
                  </li>
                  <li>
                    <b>„Частна страница"</b> — защитена зона в Платформата за
                    участници с валиден достъп, съдържаща програма, материали,
                    бутон за включване, цифрови продукти, сертификати и др.
                  </li>
                  <li>
                    <b>„Продукт"</b> — дигитален продукт или съдържание,
                    предлагано от Организатор в Частната страница срещу
                    допълнително заплащане.
                  </li>
                  <li>
                    <b>„Добавка" (Add-on)</b> — допълнителна функционалност или
                    ресурс (напр. по-голяма зала/капацитет), закупен от
                    Организатора за конкретно събитие.
                  </li>
                  <li>
                    <b>„Stripe"</b> — платежен оператор (Stripe, Inc. / Stripe
                    Payments Europe, Ltd.), чрез чиято инфраструктура се
                    обработват плащания, 3DS автентикация, Stripe Connect,
                    изплащания и спорове/chargebacks.
                  </li>
                  <li>
                    <b>„Stripe Connect акаунт"</b> — акаунт на Организатора,
                    свързан с платформения Stripe акаунт на Eventa.tv, необходим
                    за получаване на изплащания.
                  </li>
                  <li>
                    <b>„Комисионна / платформена такса"</b> — процент/фиксирана
                    сума, удържана от Eventa.tv при всяка транзакция съгласно
                    актуалния ценоразпис.
                  </li>
                  <li>
                    <b>„Афилиейт програма"</b> — схема за препращане, при която
                    трети лица получават комисионна за генерирани продажби на
                    билети чрез уникална реферална връзка.
                  </li>
                </ul>

                
                <h3>4) Същност и обхват на услугата</h3>
                <p>
                  Eventa.tv е технологична платформа „Software as a Service"
                  (SaaS), която предоставя на Организаторите следните
                  функционалности:
                </p>
                <ul>
                  <li>
                    Публична страница на събитие с описание и регистрация.
                  </li>
                  <li>
                    Частна страница за участници (материали, програма, продукти,
                    сертификати).
                  </li>
                  <li>
                    Модул за билети и ценови нива с вградено плащане чрез
                    Stripe.
                  </li>
                  <li>
                    Продажба на дигитални продукти вътре в Частната страница.
                  </li>
                  <li>
                    Стрийминг на живо чрез RTMP протокол или интеграция с Zoom.
                  </li>
                  <li>
                    Управление на участници: ръчно добавяне, CSV импорт,
                    резервации.
                  </li>
                  <li>Автоматични имейл/SMS напомняния и известия.</li>
                  <li>Издаване на персонализирани сертификати за участие.</li>
                  <li>
                    Добавки за разширен капацитет (до 300 / 500 / 1000
                    участника).
                  </li>
                  <li>Интеграции: Zapier (автоматизации), CSV, и др.</li>
                  <li>
                    Отчетност, приходен дашборд, фактуриране и изплащания на
                    организатори.
                  </li>
                  <li>
                    Афилиейт програма с реферални връзки и приходен дашборд.
                  </li>
                </ul>
                <p>
                  Eventa.tv не гарантира конкретен брой продажби, посещаемост
                  или приход за организатора. Успехът на дадено събитие зависи
                  от усилията и съдържанието на Организатора.
                </p>

                
                <h3>5) Регистрация и профили</h3>
                <ul>
                  <li>
                    За създаване на събития и/или покупка на билети/продукти е
                    необходим профил в Eventa.tv.
                  </li>
                  <li>
                    Задължавате се да предоставите точни, пълни и актуални данни
                    и да ги поддържате актуални.
                  </li>
                  <li>
                    Носите пълна отговорност за поверителността на
                    удостоверителните данни (имейл/парола) и за всички действия,
                    извършени от Вашия профил.
                  </li>
                  <li>
                    При съмнение за компрометиране на достъпа незабавно
                    уведомете Eventa.tv и сменете паролата си.
                  </li>
                  <li>
                    Eventa.tv може да ограничи, спре или прекрати достъпа при
                    нарушение на Условията, при подозрение за злоупотреба,
                    измама или при необходимост от защита на сигурността на
                    Платформата.
                  </li>
                </ul>

                
                <h3>
                  6) Роли и отговорности (Организатор – Участник – Eventa.tv)
                </h3>
                <p>
                  Eventa.tv предоставя технологична инфраструктура и
                  <b>не е организатор</b> на събитията, освен ако изрично не е
                  посочено друго.
                </p>
                <ul>
                  <li>
                    <b>Организаторът</b> носи пълна отговорност за: (i)
                    съдържанието, правилата, програмата и качеството на
                    събитието; (ii) законосъобразността на провеждането (вкл.
                    права върху материали, видео, аудио, лични данни на
                    участниците); (iii) изпълнение на обещаното към участниците
                    (материали, записи, бонуси, сертификати и др.); (iv)
                    коректността на фирмените данни, предоставени за фактуриране
                    и изплащания.
                  </li>
                  <li>
                    <b>Участникът</b> се задължава: (i) да се запознае с
                    описанието и условията на събитието преди покупка; (ii) да
                    спазва правилата, определени от Организатора и Платформата;
                    (iii) да не записва, разпространява или използва търговски
                    съдържанието на събитието без изрично разрешение.
                  </li>
                  <li>
                    <b>Eventa.tv</b> отговаря за предоставяне на платформените
                    функционалности и обработката на плащанията, доколкото е
                    технически разумно, но не гарантира непрекъснатост или
                    конкретен бизнес резултат.
                  </li>
                </ul>

                
                <h3>7) Ценови планове и такси</h3>
                <p>
                  Eventa.tv прилага следните базови ценови условия (актуалните
                  цени винаги са публикувани на страницата „Цени" на сайта):
                </p>
                <ul>
                  <li>
                    <b>Платено събитие</b> — дневна такса от <b>14 EUR/ден</b>
                    плюс минимална комисионна върху всяка продадена билетна
                    транзакция.
                  </li>
                  <li>
                    <b>Безплатно събитие</b> — дневна такса от <b>14 EUR/ден</b>
                    без допълнителна комисионна (билетите са безплатни).
                  </li>
                  <li>
                    <b>Благотворително събитие</b> — по договаряне; до 1 000
                    участника при специални условия (свържете се с нас).
                  </li>
                </ul>
                <p>
                  Капацитетни добавки за по-голям брой участника (per-event
                  add-ons):
                </p>
                <ul>
                  <li>
                    До <b>300 участника</b> — <b>19 EUR</b>
                  </li>
                  <li>
                    До <b>500 участника</b> — <b>49 EUR</b>
                  </li>
                  <li>
                    До <b>1 000 участника</b> — <b>139 EUR</b>
                  </li>
                </ul>
                <p>
                  Към всички такси на Eventa.tv се прилагат отделно и таксите на
                  Stripe съгласно тяхните публично обявени условия. Eventa.tv си
                  запазва правото да актуализира ценоразписа с предварително
                  уведомление.
                </p>

                
                <h3>
                  8) Билети, устройствени ограничения и достъп
                </h3>
                <ul>
                  <li>
                    Билетът предоставя право на достъп на <b>един участник</b>
                    от едно устройство. Всеки билет е
                    <b>личен и по правило непрехвърляем</b>, освен ако
                    Организаторът или Платформата изрично не позволят промяна.
                  </li>
                  <li>
                    Платформата може да прилага
                    <b>ограничение на свързаните устройства</b> — при активиране
                    едновременното включване от повече от едно устройство с един
                    и същ билет може да бъде блокирано.
                  </li>
                  <li>
                    Достъпът до Частната страница се активира според статуса на
                    достъпа и настройката „видима след" (дата/час), зададена от
                    Организатора.
                  </li>
                  <li>
                    Максималният брой участника е ограничен от избрания план и
                    закупените добавки. Организаторът е отговорен да осигури
                    достатъчен капацитет преди публикуването на събитието.
                  </li>
                  <li>
                    Продължителността на събитието е ограничена до
                    <b>30 часа</b> (общо) в рамките на закупения дневен план.
                  </li>
                </ul>

                
                <h3>9) Плащания</h3>
                <p>
                  Всички парични транзакции в Платформата се обработват чрез
                  <b>Stripe</b>. Eventa.tv
                  <b>не съхранява данни за банкови карти</b>; картовите данни се
                  обработват директно от Stripe съгласно стандарта PCI DSS.
                </p>
                <ul>
                  <li>
                    <b>Плащания на участници</b> — покупка на билет или
                    дигитален продукт се обработва чрез Stripe PaymentIntent;
                    при необходимост се прилага 3DS автентикация (SCA).
                  </li>
                  <li>
                    <b>Плащания на организатори</b> — такси за публикуване на
                    събитие и за добавки се събират чрез запазена платежна карта
                    или инициирана транзакция от Организатора в Платформата.
                  </li>
                  <li>
                    <b>Постъпване на средства</b> — при покупка на билет/продукт
                    от участник, сумите
                    <b>постъпват първоначално в Stripe акаунта на Eventa.tv</b>,
                    за да могат при необходимост да се управляват
                    възстановявания и спорове/chargebacks.
                  </li>
                  <li>
                    Eventa.tv удържа <b>комисионната/платформената такса</b>
                    (application fee) при всяка билетна транзакция. Остатъкът е
                    нетната печалба на Организатора.
                  </li>
                  <li>
                    Таксите на Stripe се прилагат отделно и не се включват в
                    платформената такса на Eventa.tv.
                  </li>
                </ul>

                
                <h3>
                  10) Stripe Connect и изплащания към Организатора
                </h3>
                <ul>
                  <li>
                    За да получава изплащания, Организаторът трябва да свърже
                    <b>Stripe Connect акаунт</b> чрез настройките на профила.
                    При неактивен или непълно верифициран Stripe Connect акаунт
                    изплащания <b>не се извършват</b>.
                  </li>
                  <li>
                    Изплащането на нетната печалба на Организатора се извършва
                    <b>не по-рано от 7 (седем) дни след приключване</b> на
                    събитието, при условие че: (i) няма активни
                    спорове/chargebacks; (ii) няма данни за злоупотреба или
                    нарушения; (iii) Организаторът е предоставил необходимите
                    данни за фактуриране и пореден номер на фактура (вж. §12);
                    (iv) няма неизяснени задължения към Платформата; (v) няма
                    законови или технически ограничения.
                  </li>
                  <li>
                    При активен спор/chargeback Eventa.tv може временно да
                    задържи изплащането и/или да прихване свързани разходи/такси
                    в допустимата от закона степен.
                  </li>
                  <li>
                    Организаторът може да следи статуса на плащанията („За
                    изплащане", „Задържани", „Изплатено", „Възстановено") в
                    раздел „Приходи" на своя профил.
                  </li>
                  <li>
                    Eventa.tv може да предостави линк към Stripe Express
                    Dashboard за преглед на детайлите по транзакциите.
                  </li>
                </ul>

                
                <h3>11) Възстановявания (Refund Policy)</h3>
                <HighlightBox>
                  <b>Ключово правило:</b> След началото на събитието
                  <b>не се извършват възстановявания</b>. Възстановяване е
                  възможно само преди началото на събитието, или ако събитието
                  <b>не е стартирало/не е излъчено изобщо</b>.
                </HighlightBox>
                <ul>
                  <li>
                    Всички възстановявания се обработват чрез Stripe.
                    Обработката може да отнеме 5–10 работни дни в зависимост от
                    банката на участника.
                  </li>
                  <li>
                    След началото на събитието <b>не се извършва</b>
                    възстановяване, включително при: неявяване на участника,
                    технически проблеми от страна на участника, липса на
                    устройство/интернет, несъгласие с програмата след
                    провеждането.
                  </li>
                  <li>
                    <b>Изключение:</b> когато събитието не е започнало/не е
                    излъчено изобщо (напр. при отмяна или непровеждане от страна
                    на Организатора). В тези случаи може да бъде извършено пълно
                    или частично възстановяване.
                  </li>
                  <li>
                    Правото на отказ по ЗЗП (Закон за защита на потребителите)
                    не се прилага за услуги, свързани със свободното време, при
                    конкретна дата/период (чл. 57, т. 12 ЗЗП) — каквито са
                    билетите за събития с фиксирана дата.
                  </li>
                  <li>
                    За дигитални продукти/съдържание, предоставени незабавно
                    след покупка, правото на отказ може да не се прилага при
                    наличие на изрично съгласие на участника преди изтеглянето
                    (когато е приложимо по закон).
                  </li>
                  <li>
                    При установена злоупотреба (напр. chargeback без основание)
                    Eventa.tv си запазва правото да ограничи бъдещия достъп на
                    съответния потребител.
                  </li>
                </ul>

                
                <h3>12) Фактуриране</h3>
                <ul>
                  <li>
                    <b>Фактури към участници:</b> АТОМИКА ГРУП ЕООД издава
                    фактура към участник <b>само при изрично поискване</b> и при
                    предоставяне на пълните данни за фактуриране (фирма, ЕИК,
                    ДДС номер, адрес, МОЛ).
                  </li>
                  <li>
                    <b>Фактури към организатори за платформени разходи:</b>
                    АТОМИКА ГРУП ЕООД издава фактури на Организатори за техните
                    разходи в Платформата <b>само при изрично поискване</b>.
                  </li>
                  <li>
                    <b>Фактура от Организатора към Eventa.tv (за изплащане):</b>
                    За да получи изплащане на нетната печалба, Организаторът е
                    длъжен да предостави коректни фирмени данни и
                    <b>пореден номер на фактура</b>. Въз основа на тях Eventa.tv
                    може да генерира документ <b>от името на Организатора</b>
                    към АТОМИКА ГРУП ЕООД с цел счетоводно оформяне на
                    изплащането.
                  </li>
                  <li>
                    Организаторът носи <b>пълна отговорност за коректността</b>
                    на предоставените данни (ЕИК/ДДС номер, адрес, МОЛ, пореден
                    номер и др.) и за собствените си счетоводни и данъчни
                    задължения. Eventa.tv
                    <b>не предоставя счетоводни или данъчни консултации</b>.
                  </li>
                  <li>
                    Организаторите, регистрирани по ЗДДС, носят отговорност за
                    коректното начисляване и деклариране на ДДС съобразно
                    приложимото законодателство. Eventa.tv показва прогнозно ДДС
                    изчисление в приходния дашборд, което е само информативно.
                  </li>
                </ul>

                
                <h3>13) Афилиейт програма</h3>
                <ul>
                  <li>
                    Eventa.tv предоставя афилиейт програма, чрез която трети
                    лица могат да получат реферална връзка и да печелят
                    комисионна за генерирани продажби на билети.
                  </li>
                  <li>
                    Условията, процентите и изплащанията по афилиейт програмата
                    са описани в съответния раздел на Платформата и могат да
                    бъдат актуализирани.
                  </li>
                  <li>
                    Изплащанията на афилиейт комисионни подлежат на същите
                    изисквания за Stripe Connect и фактуриране, описани в §10 и
                    §12.
                  </li>
                  <li>
                    Забранено е изкуственото генериране на кликове или
                    транзакции с цел злоупотреба с афилиейт програмата.
                    Eventa.tv може да прекрати участието при съмнение за
                    злоупотреба.
                  </li>
                </ul>

                
                <h3>14) Сертификати</h3>
                <ul>
                  <li>
                    Организаторът може да активира модула за сертификати и да
                    генерира персонализирани сертификати за участие за своите
                    участници.
                  </li>
                  <li>
                    Организаторът носи отговорност за съдържанието, оформлението
                    и евентуалните правни/образователни импликации на издаваните
                    сертификати. Eventa.tv предоставя единствено техническата
                    инфраструктура за генериране и доставка на PDF документите.
                  </li>
                </ul>

                
                <h3>15) Интеграции и външни услуги</h3>
                <ul>
                  <li>
                    Платформата интегрира или може да интегрира услуги на трети
                    страни: <b>Stripe</b> (плащания), <b>Zoom</b>
                    (видеоконференции), <b>Zapier</b> (автоматизации), имейл и
                    SMS доставчици, RTMP стрийминг платформи и др.
                  </li>
                  <li>
                    Eventa.tv <b>не носи отговорност</b> за прекъсвания, промени
                    в условията, ограничения, грешки или недостъпност на услуги
                    на трети страни, включително Zoom и Zapier.
                  </li>
                  <li>
                    При използване на интеграции с трети страни се прилагат и
                    техните условия за ползване и политики за поверителност.
                  </li>
                  <li>
                    Организаторът носи отговорност за коректното конфигуриране
                    на интеграциите (напр. Zapier webhook токени, Zoom линкове)
                    и за последствията от неправилно настройване.
                  </li>
                </ul>

                
                <h3>16) Забранени дейности и съдържание</h3>
                <p>При използването на Платформата е забранено:</p>
                <ul>
                  <li>
                    Публикуване на незаконно съдържание или съдържание,
                    нарушаващо авторски права, търговски марки или права на
                    личността.
                  </li>
                  <li>
                    Измами, подвеждане на участници, фалшиви описания на
                    събитие.
                  </li>
                  <li>
                    Реч на омразата, тормоз, дискриминация или подбуждане към
                    насилие.
                  </li>
                  <li>
                    Опити за неоторизиран достъп до системи, заобикаляне на
                    технически мерки за защита или обратно инженерство на
                    Платформата.
                  </li>
                  <li>
                    Записване, разпространение или препродажба на съдържание на
                    събитие без изрично писмено разрешение на Организатора.
                  </li>
                  <li>
                    Разпространение на зловреден код, спам или нежелани
                    търговски съобщения.
                  </li>
                  <li>
                    Изкуствено генериране на транзакции, кликове или
                    регистрации.
                  </li>
                </ul>
                <p>
                  При нарушение Eventa.tv може незабавно да ограничи, спре или
                  прекрати достъпа до профила и/или събитието, без да дължи
                  обезщетение.
                </p>

                
                <h3>17) Интелектуална собственост</h3>
                <ul>
                  <li>
                    Всички права върху Платформата (код, дизайн, търговски
                    марки, интерфейси, документация) са собственост на АТОМИКА
                    ГРУП ЕООД или на съответните правоносители.
                  </li>
                  <li>
                    Като качвате съдържание (текст, изображения, видео, лого и
                    др.) в Платформата, Вие предоставяте на Eventa.tv
                    неизключителен, безвъзмезден лиценз за използването му
                    единствено с цел предоставяне на услугата (визуализация,
                    технически операции, маркетинг на Платформата).
                  </li>
                  <li>
                    Вие гарантирате, че притежавате правата върху каченото
                    съдържание и то не нарушава права на трети лица.
                  </li>
                </ul>

                
                <h3>18) Наличност на услугата</h3>
                <ul>
                  <li>
                    Eventa.tv полага разумни усилия за осигуряване на
                    непрекъснатост, но Платформата може временно да бъде
                    недостъпна поради планирана поддръжка, обновления или
                    извънредни обстоятелства.
                  </li>
                  <li>
                    Eventa.tv не носи отговорност за неизправности, прекъсвания
                    или промени в услугите на трети страни (Stripe, Zoom,
                    интернет доставчици и др.).
                  </li>
                  <li>
                    При планирана поддръжка, засягаща активни събития, Eventa.tv
                    ще положи разумни усилия за предварително уведомяване.
                  </li>
                </ul>

                
                <h3>19) Ограничение на отговорността</h3>
                <ul>
                  <li>
                    Услугата се предоставя „каквато е" и „каквато е налична". В
                    максимално допустимата от закона степен Eventa.tv изключва
                    всякакви гаранции за търговска пригодност, годност за
                    конкретна цел или непрекъснатост.
                  </li>
                  <li>
                    Eventa.tv не носи отговорност за: (i) косвени, последващи
                    или наказателни вреди; (ii) пропуснати ползи или приходи;
                    (iii) загуба на данни; (iv) съдържание, действия или
                    бездействия на Организатори или Участници.
                  </li>
                  <li>
                    Сумарната отговорност на Eventa.tv към Организатор за
                    платени услуги е ограничена до размера на платформените
                    такси, получени от Eventa.tv за последните
                    <b>3 (три) месеца</b> по конкретното събитие/акаунт,
                    доколкото е допустимо от приложимото законодателство.
                  </li>
                </ul>

                
                <h3>20) Обезщетение (Indemnity)</h3>
                <p>
                  Организаторът се задължава да обезщети и освободи от
                  отговорност Eventa.tv, нейните служители, директори и
                  партньори от всякакви претенции, щети, глоби, разходи
                  (включително разумни адвокатски хонорари), произтичащи от: (i)
                  съдържанието и/или провеждането на събитието; (ii) нарушение
                  на права на трети лица (авторски права, търговски марки, лични
                  данни и др.); (iii) неспазване на приложимото законодателство;
                  (iv) спор между Участник и Организатор, доколкото спорът е
                  причинен от действия или бездействия на Организатора.
                </p>

                
                <h3>21) Защита на личните данни</h3>
                <p>
                  Обработването на лични данни се извършва в съответствие с
                  Политиката за поверителност и Политиката за бисквитки на
                  Eventa.tv, публикувани на сайта. Stripe обработва данните за
                  картовите транзакции като самостоятелен администратор,
                  съгласно собствената си политика за поверителност.
                  Организаторите, събиращи лични данни на участниците чрез
                  Платформата, действат като самостоятелни администратори на
                  лични данни и носят пълна отговорност за законосъобразността
                  на обработването.
                </p>

                
                <h3>22) Промени в условията</h3>
                <p>
                  Eventa.tv може да актуализира настоящите Условия по всяко
                  време. Промените влизат в сила от датата на публикуването им
                  на сайта. При съществени промени ще положим разумни усилия да
                  Ви уведомим (напр. чрез имейл или известие в Платформата).
                  Продължаването на ползването на Платформата след влизане в
                  сила на промените означава приемане на актуализираните
                  Условия.
                </p>

                
                <h3>23) Прекратяване</h3>
                <ul>
                  <li>
                    Можете да прекратите ползването по всяко време, при условие
                    че няма активни неприключени събития, неизяснени
                    плащания/спорове или законови изисквания за съхранение на
                    данни.
                  </li>
                  <li>
                    Eventa.tv може да прекрати или ограничи достъпа при
                    нарушение на Условията, по правни причини или с цел защита
                    на сигурността на Платформата, без предварително уведомление
                    при неотложни случаи.
                  </li>
                  <li>
                    При прекратяване на акаунта, изплащането на евентуална
                    остатъчна печалба се извършва при спазване на изискванията
                    по §10 и §12, включително завършване на Stripe Connect
                    верификацията.
                  </li>
                </ul>

                
                <h3>
                  24) Приложимо право и разрешаване на спорове
                </h3>
                <ul>
                  <li>
                    За настоящите Условия и всички отношения, произтичащи от
                    използването на Платформата, се прилага
                    <b>българското право</b>.
                  </li>
                  <li>
                    Споровете се решават предимно по взаимно съгласие. При
                    непостигане на съгласие, компетентен е съответният
                    <b> български съд</b> по седалището на АТОМИКА ГРУП ЕООД.
                  </li>
                  <li>
                    Потребителите (физически лица) могат да използват
                    извънсъдебни способи за разрешаване на спорове съгласно ЗЗП
                    и Регламент (ЕС) № 524/2013, включително Платформата за
                    онлайн решаване на спорове на ЕК:
                    <a
                      href="https://ec.europa.eu/consumers/odr"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      ec.europa.eu/consumers/odr
                    </a>
                    .
                  </li>
                </ul>

                
                <h3>25) Контакт</h3>
                <p>
                  За въпроси, сигнали или жалби относно настоящите Условия
                  използвайте формата за контакт на сайта <b>eventa.tv</b> или
                  се свържете с нас на адрес:
                </p>
                <ContactBox>
                  <b>АТОМИКА ГРУП ЕООД</b>
                  <br />
                  ЕИК: 205822763 | ДДС: BG205822763
                  <br />
                  България, гр. Велико Търново, ул. „Никола Габровски" 63-б
                  <br />
                  Имейл: <a href="mailto:info@eventa.tv">info@eventa.tv</a>
                </ContactBox>
              </div>`,
  en: `<div >
                <p class="meta">Last updated: 5 April 2026</p>

                <div class="intro">
                  These Terms of Use (“Terms”) govern all use of the Eventa.tv
                  platform by organisers, participants and visitors. By accessing
                  and/or using the platform—including creating an account,
                  publishing or attending an event, or purchasing a ticket or
                  product—you expressly accept the Terms and all related policies.
                </div>

                
                <h3>1) Who we are</h3>
                <p>
                  The Eventa.tv platform is operated by <b>ATOMICA GROUP Ltd</b>
                  , company registration number (EIK) <b>205822763</b>, VAT
                  registered: <b>BG205822763</b>, registered office and business
                  address: Bulgaria, Veliko Tarnovo, 63-b Nikola Gabrovski Street.
                  Legal form: limited liability company (OOD) (hereinafter
                  “Eventa.tv”, “the Platform”, “we”, “us”).
                </p>

                
                <h3>2) Acceptance of the Terms</h3>
                <p>
                  By accessing or using Eventa.tv you confirm that you are at least
                  18 years of age (or act with proper consent of a legal
                  representative), have the right to enter into a binding contract,
                  and accept these Terms, the Privacy Policy and the Cookie Policy.
                  If you do not agree, please do not use the Platform.
                </p>

                
                <h3>3) Definitions</h3>
                <ul>
                  <li>
                    <b>“Platform” / “Eventa.tv”</b> — the website, APIs, mobile
                    interfaces and systems of ATOMICA GROUP Ltd for organising and
                    managing online and hybrid events.
                  </li>
                  <li>
                    <b>“Organiser”</b> — a natural or legal person that creates,
                    publishes and manages events through the Platform.
                  </li>
                  <li>
                    <b>“Participant”</b> — a person who registers, purchases a
                    ticket and/or product and/or attends an event through the
                    Platform.
                  </li>
                  <li>
                    <b>“Event”</b> — an online or hybrid event (conference,
                    webinar, course, etc.) published by an Organiser, delivered via
                    RTMP streaming, Zoom or another approved integration.
                  </li>
                  <li>
                    <b>“Ticket”</b> — a personal, non-transferable right of access
                    to a specific event and/or the Private Page, subject to the
                    stated conditions and restrictions.
                  </li>
                  <li>
                    <b>“Private Page”</b> — a protected area of the Platform for
                    participants with valid access, containing the programme,
                    materials, join button, digital products, certificates, etc.
                  </li>
                  <li>
                    <b>“Product”</b> — a digital product or content offered by the
                    Organiser on the Private Page for an additional fee.
                  </li>
                  <li>
                    <b>“Add-on”</b> — additional functionality or resource (e.g.
                    larger room/capacity) purchased by the Organiser for a specific
                    event.
                  </li>
                  <li>
                    <b>“Stripe”</b> — payment services provider (Stripe, Inc. /
                    Stripe Payments Europe, Ltd.), whose infrastructure processes
                    payments, 3DS authentication, Stripe Connect, payouts and
                    disputes/chargebacks.
                  </li>
                  <li>
                    <b>“Stripe Connect account”</b> — the Organiser’s account linked
                    to Eventa.tv’s platform Stripe account, required to receive
                    payouts.
                  </li>
                  <li>
                    <b>“Commission / platform fee”</b> — percentage/fixed amount
                    retained by Eventa.tv on each transaction in accordance with the
                    current price list.
                  </li>
                  <li>
                    <b>“Affiliate programme”</b> — a referral scheme under which third
                    parties earn commission on ticket sales generated through a
                    unique referral link.
                  </li>
                </ul>

                
                <h3>4) Nature and scope of the service</h3>
                <p>
                  Eventa.tv is a technology platform “Software as a Service” (SaaS)
                  that provides Organisers with the following functionality:
                </p>
                <ul>
                  <li>
                    Public event page with description and registration.
                  </li>
                  <li>
                    Private page for participants (materials, programme, products,
                    certificates).
                  </li>
                  <li>
                    Ticketing module and price tiers with integrated payment via
                    Stripe.
                  </li>
                  <li>
                    Sale of digital products within the Private Page.
                  </li>
                  <li>
                    Live streaming via RTMP protocol or Zoom integration.
                  </li>
                  <li>
                    Participant management: manual addition, CSV import,
                    reservations.
                  </li>
                  <li>Automated email/SMS reminders and notifications.</li>
                  <li>Issuance of personalised participation certificates.</li>
                  <li>
                    Add-ons for extended capacity (up to 300 / 500 / 1,000
                    participants).
                  </li>
                  <li>Integrations: Zapier (automations), CSV, etc.</li>
                  <li>
                    Reporting, revenue dashboard, invoicing and payouts to
                    organisers.
                  </li>
                  <li>
                    Affiliate programme with referral links and revenue dashboard.
                  </li>
                </ul>
                <p>
                  Eventa.tv does not guarantee a specific number of sales,
                  attendance or revenue for any organiser. The success of an event
                  depends on the Organiser’s efforts and content.
                </p>

                
                <h3>5) Registration and accounts</h3>
                <ul>
                  <li>
                    Creating events and/or purchasing tickets/products requires an
                    Eventa.tv account.
                  </li>
                  <li>
                    You undertake to provide accurate, complete and up-to-date data
                    and to keep it updated.
                  </li>
                  <li>
                    You bear full responsibility for the confidentiality of your
                    credentials (email/password) and for all actions carried out via
                    your account.
                  </li>
                  <li>
                    If you suspect unauthorised access, notify Eventa.tv
                    immediately and change your password.
                  </li>
                  <li>
                    Eventa.tv may restrict, suspend or terminate access in case of a
                    breach of the Terms, suspected abuse or fraud, or where
                    necessary to protect the security of the Platform.
                  </li>
                </ul>

                
                <h3>
                  6) Roles and responsibilities (Organiser – Participant –
                  Eventa.tv)
                </h3>
                <p>
                  Eventa.tv provides technological infrastructure and
                  <b>is not the organiser</b> of events unless expressly stated
                  otherwise.
                </p>
                <ul>
                  <li>
                    <b>The Organiser</b> is fully responsible for: (i) the content,
                    rules, programme and quality of the event; (ii) lawful conduct
                    of the event (including rights in materials, video, audio,
                    participants’ personal data); (iii) delivering what was promised
                    to participants (materials, recordings, bonuses, certificates,
                    etc.); (iv) the accuracy of business data provided for invoicing
                    and payouts.
                  </li>
                  <li>
                    <b>The Participant</b> undertakes: (i) to review the event
                    description and conditions before purchase; (ii) to comply with
                    rules set by the Organiser and the Platform; (iii) not to
                    record, distribute or commercially exploit event content without
                    express permission.
                  </li>
                  <li>
                    <b>Eventa.tv</b> is responsible for providing platform
                    functionality and processing payments to the extent technically
                    reasonable, but does not guarantee uninterrupted availability or
                    any particular business outcome.
                  </li>
                </ul>

                
                <h3>7) Pricing plans and fees</h3>
                <p>
                  Eventa.tv applies the following base pricing (current prices are
                  always published on the “Pricing” page of the website):
                </p>
                <ul>
                  <li>
                    <b>Paid event</b> — daily fee of <b>14 EUR/day</b> plus minimum
                    commission on each ticket sale transaction.
                  </li>
                  <li>
                    <b>Free event</b> — daily fee of <b>14 EUR/day</b> without
                    additional commission (tickets are free).
                  </li>
                  <li>
                    <b>Charitable event</b> — by arrangement; up to 1,000
                    participants under special conditions (contact us).
                  </li>
                </ul>
                <p>
                  Capacity add-ons for higher participant numbers (per-event
                  add-ons):
                </p>
                <ul>
                  <li>
                    Up to <b>300 participants</b> — <b>19 EUR</b>
                  </li>
                  <li>
                    Up to <b>500 participants</b> — <b>49 EUR</b>
                  </li>
                  <li>
                    Up to <b>1,000 participants</b> — <b>139 EUR</b>
                  </li>
                </ul>
                <p>
                  Stripe fees apply separately to all Eventa.tv charges in accordance
                  with Stripe’s publicly stated terms. Eventa.tv reserves the right
                  to update the price list with prior notice.
                </p>

                
                <h3>
                  8) Tickets, device limits and access
                </h3>
                <ul>
                  <li>
                    A ticket grants access for <b>one participant</b> from one
                    device. Each ticket is <b>personal and as a rule non-transferable</b>,
                    unless the Organiser or the Platform expressly allows a change.
                  </li>
                  <li>
                    The Platform may apply a <b>limit on linked devices</b> — when
                    enabled, simultaneous joining from more than one device with the
                    same ticket may be blocked.
                  </li>
                  <li>
                    Access to the Private Page is activated according to access
                    status and the “visible after” setting (date/time) configured by
                    the Organiser.
                  </li>
                  <li>
                    The maximum number of participants is limited by the selected plan
                    and purchased add-ons. The Organiser is responsible for ensuring
                    sufficient capacity before publishing the event.
                  </li>
                  <li>
                    Event duration is limited to <b>30 hours</b> (total) within the
                    purchased daily plan.
                  </li>
                </ul>

                
                <h3>9) Payments</h3>
                <p>
                  All monetary transactions on the Platform are processed via
                  <b>Stripe</b>. Eventa.tv <b>does not store card data</b>; card data
                  are processed directly by Stripe in accordance with PCI DSS.
                </p>
                <ul>
                  <li>
                    <b>Participant payments</b> — purchase of a ticket or digital
                    product is processed via Stripe PaymentIntent; where required, 3DS
                    authentication (SCA) applies.
                  </li>
                  <li>
                    <b>Organiser payments</b> — fees for publishing an event and for
                    add-ons are collected via a stored payment card or a transaction
                    initiated by the Organiser in the Platform.
                  </li>
                  <li>
                    <b>Receipt of funds</b> — when a participant purchases a
                    ticket/product, amounts <b>initially arrive in Eventa.tv’s Stripe
                    account</b> so that refunds and disputes/chargebacks can be
                    managed where necessary.
                  </li>
                  <li>
                    Eventa.tv retains the <b>commission/platform fee</b> (application
                    fee) on each ticket transaction. The remainder is the Organiser’s
                    net revenue.
                  </li>
                  <li>
                    Stripe fees are charged separately and are not included in
                    Eventa.tv’s platform fee.
                  </li>
                </ul>

                
                <h3>
                  10) Stripe Connect and payouts to the Organiser
                </h3>
                <ul>
                  <li>
                    To receive payouts, the Organiser must connect a <b>Stripe
                    Connect account</b> via account settings. If the Stripe Connect
                    account is inactive or not fully verified, payouts <b>will not
                    be made</b>.
                  </li>
                  <li>
                    Payout of the Organiser’s net revenue is made <b>no earlier than
                    7 (seven) days after the end</b> of the event, provided that:
                    (i) there are no active disputes/chargebacks; (ii) there is no
                    indication of abuse or breaches; (iii) the Organiser has provided
                    the necessary invoicing data and sequential invoice number (see
                    Section 12); (iv) there are no outstanding obligations to the
                    Platform; (v) there are no legal or technical impediments.
                  </li>
                  <li>
                    Where a dispute/chargeback is active, Eventa.tv may temporarily
                    withhold payout and/or offset related costs/fees to the extent
                    permitted by law.
                  </li>
                  <li>
                    The Organiser can track payment status (“Due for payout”,
                    “Held”, “Paid”, “Refunded”) in the “Revenue” section of their
                    profile.
                  </li>
                  <li>
                    Eventa.tv may provide a link to the Stripe Express Dashboard for
                    transaction details.
                  </li>
                </ul>

                
                <h3>11) Refunds (Refund Policy)</h3>
                <HighlightBox>
                  <b>Key rule:</b> After the event has started <b>no refunds are
                  issued</b>. A refund is possible only before the event starts, or
                  if the event <b>has not started/has not been broadcast at all</b>.
                </HighlightBox>
                <ul>
                  <li>
                    All refunds are processed via Stripe. Processing may take 5–10
                    business days depending on the participant’s bank.
                  </li>
                  <li>
                    After the event has started <b>no</b> refund is issued,
                    including for: participant no-show, technical issues on the
                    participant’s side, lack of device/internet, disagreement with the
                    programme after the event.
                  </li>
                  <li>
                    <b>Exception:</b> where the event has not started/has not been
                    broadcast at all (e.g. cancellation or non-performance by the
                    Organiser). In those cases a full or partial refund may be made.
                  </li>
                  <li>
                    The statutory withdrawal right under consumer protection rules does
                    not apply to leisure services on a specific date/in a specific
                    period (Article 57(12) of the Bulgarian Consumer Protection Act)—
                    as applies to tickets for fixed-date events.
                  </li>
                  <li>
                    For digital products/content delivered immediately after purchase,
                    the withdrawal right may not apply where the participant has given
                    explicit consent before download (where applicable by law).
                  </li>
                  <li>
                    Where abuse is established (e.g. chargeback without grounds),
                    Eventa.tv reserves the right to restrict future access for the
                    relevant user.
                  </li>
                </ul>

                
                <h3>12) Invoicing</h3>
                <ul>
                  <li>
                    <b>Invoices to participants:</b> ATOMICA GROUP Ltd issues an
                    invoice to a participant <b>only upon explicit request</b> and
                    upon provision of complete invoicing details (company name,
                    registration number, VAT number, address, authorised person).
                  </li>
                  <li>
                    <b>Invoices to organisers for platform expenses:</b> ATOMICA
                    GROUP Ltd issues invoices to Organisers for their Platform
                    expenses <b>only upon explicit request</b>.
                  </li>
                  <li>
                    <b>Invoice from Organiser to Eventa.tv (for payout):</b> To
                    receive payout of net revenue, the Organiser must provide correct
                    business data and a <b>sequential invoice number</b>. Based on
                    these, Eventa.tv may generate a document <b>on behalf of the
                    Organiser</b> to ATOMICA GROUP Ltd for accounting settlement of
                    the payout.
                  </li>
                  <li>
                    The Organiser bears <b>full responsibility for the accuracy</b> of
                    the data provided (registration/VAT number, address, authorised
                    person, sequential number, etc.) and for their own accounting and
                    tax obligations. Eventa.tv <b>does not provide accounting or tax
                    advice</b>.
                  </li>
                  <li>
                    VAT-registered Organisers are responsible for correct VAT
                    charging and declaration in accordance with applicable law. Eventa.tv
                    displays indicative VAT calculations on the revenue dashboard for
                    information only.
                  </li>
                </ul>

                
                <h3>13) Affiliate programme</h3>
                <ul>
                  <li>
                    Eventa.tv provides an affiliate programme allowing third parties to
                    obtain a referral link and earn commission on generated ticket
                    sales.
                  </li>
                  <li>
                    Terms, percentages and payouts under the affiliate programme are
                    described in the relevant section of the Platform and may be
                    updated.
                  </li>
                  <li>
                    Affiliate commission payouts are subject to the same Stripe Connect
                    and invoicing requirements described in Sections 10 and 12.
                  </li>
                  <li>
                    Artificial generation of clicks or transactions to abuse the
                    affiliate programme is prohibited. Eventa.tv may terminate
                    participation if abuse is suspected.
                  </li>
                </ul>

                
                <h3>14) Certificates</h3>
                <ul>
                  <li>
                    The Organiser may enable the certificates module and generate
                    personalised participation certificates for participants.
                  </li>
                  <li>
                    The Organiser is responsible for the content, layout and any
                    legal/educational implications of issued certificates. Eventa.tv
                    provides only the technical infrastructure for generating and
                    delivering PDF documents.
                  </li>
                </ul>

                
                <h3>15) Integrations and third-party services</h3>
                <ul>
                  <li>
                    The Platform integrates or may integrate third-party services:
                    <b>Stripe</b> (payments), <b>Zoom</b> (video conferencing),
                    <b>Zapier</b> (automations), email and SMS providers, RTMP
                    streaming platforms, etc.
                  </li>
                  <li>
                    Eventa.tv <b>is not liable</b> for outages, changes to terms,
                    restrictions, errors or unavailability of third-party services,
                    including Zoom and Zapier.
                  </li>
                  <li>
                    When using third-party integrations, their terms of use and privacy
                    policies also apply.
                  </li>
                  <li>
                    The Organiser is responsible for correct configuration of
                    integrations (e.g. Zapier webhook tokens, Zoom links) and for the
                    consequences of misconfiguration.
                  </li>
                </ul>

                
                <h3>16) Prohibited activities and content</h3>
                <p>The following is prohibited when using the Platform:</p>
                <ul>
                  <li>
                    Publishing illegal content or content that infringes copyright,
                    trademarks or personality rights.
                  </li>
                  <li>
                    Fraud, misleading participants, false event descriptions.
                  </li>
                  <li>
                    Hate speech, harassment, discrimination or incitement to violence.
                  </li>
                  <li>
                    Attempts at unauthorised access to systems, circumvention of
                    technical protection measures or reverse engineering of the
                    Platform.
                  </li>
                  <li>
                    Recording, distributing or reselling event content without express
                    written permission from the Organiser.
                  </li>
                  <li>
                    Distribution of malware, spam or unsolicited commercial messages.
                  </li>
                  <li>
                    Artificial generation of transactions, clicks or registrations.
                  </li>
                </ul>
                <p>
                  In case of a breach, Eventa.tv may immediately restrict, suspend or
                  terminate access to the account and/or event without owing
                  compensation.
                </p>

                
                <h3>17) Intellectual property</h3>
                <ul>
                  <li>
                    All rights in the Platform (code, design, trademarks, interfaces,
                    documentation) belong to ATOMICA GROUP Ltd or the respective
                    rights holders.
                  </li>
                  <li>
                    By uploading content (text, images, video, logos, etc.) to the
                    Platform, you grant Eventa.tv a non-exclusive, royalty-free
                    licence to use it solely for providing the service (display,
                    technical operations, marketing of the Platform).
                  </li>
                  <li>
                    You warrant that you own the rights to uploaded content and that it
                    does not infringe third-party rights.
                  </li>
                </ul>

                
                <h3>18) Service availability</h3>
                <ul>
                  <li>
                    Eventa.tv makes reasonable efforts to ensure availability, but the
                    Platform may be temporarily unavailable due to planned maintenance,
                    updates or force majeure.
                  </li>
                  <li>
                    Eventa.tv is not liable for failures, outages or changes in
                    third-party services (Stripe, Zoom, internet providers, etc.).
                  </li>
                  <li>
                    For planned maintenance affecting live events, Eventa.tv will make
                    reasonable efforts to notify in advance.
                  </li>
                </ul>

                
                <h3>19) Limitation of liability</h3>
                <ul>
                  <li>
                    The service is provided “as is” and “as available”. To the maximum
                    extent permitted by law, Eventa.tv disclaims all warranties of
                    merchantability, fitness for a particular purpose or uninterrupted
                    operation.
                  </li>
                  <li>
                    Eventa.tv is not liable for: (i) indirect, consequential or
                    punitive damages; (ii) lost profits or revenue; (iii) loss of data;
                    (iv) content, acts or omissions of Organisers or Participants.
                  </li>
                  <li>
                    Eventa.tv’s aggregate liability to an Organiser for paid services
                    is limited to the amount of platform fees received by Eventa.tv in
                    the last <b>3 (three) months</b> for the specific event/account,
                    to the extent permitted by applicable law.
                  </li>
                </ul>

                
                <h3>20) Indemnity</h3>
                <p>
                  The Organiser undertakes to indemnify and hold harmless Eventa.tv,
                  its employees, directors and partners from any claims, damages,
                  fines, costs (including reasonable legal fees) arising from: (i) the
                  content and/or conduct of the event; (ii) infringement of third-party
                  rights (copyright, trademarks, personal data, etc.); (iii)
                  non-compliance with applicable law; (iv) disputes between Participant
                  and Organiser, to the extent caused by acts or omissions of the
                  Organiser.
                </p>

                
                <h3>21) Personal data protection</h3>
                <p>
                  Processing of personal data is carried out in accordance with the
                  Privacy Policy and Cookie Policy of Eventa.tv published on the
                  website. Stripe processes card transaction data as an independent
                  controller under its own privacy policy. Organisers who collect
                  participants’ personal data through the Platform act as independent
                  controllers and bear full responsibility for lawful processing.
                </p>

                
                <h3>22) Changes to the Terms</h3>
                <p>
                  Eventa.tv may update these Terms at any time. Changes take effect from
                  the date of publication on the website. For material changes we will
                  make reasonable efforts to notify you (e.g. by email or in-platform
                  notice). Continued use of the Platform after changes take effect means
                  acceptance of the updated Terms.
                </p>

                
                <h3>23) Termination</h3>
                <ul>
                  <li>
                    You may stop using the service at any time, provided there are no
                    active unfinished events, outstanding payments/disputes or legal
                    data retention requirements.
                  </li>
                  <li>
                    Eventa.tv may terminate or restrict access in case of breach of the
                    Terms, for legal reasons or to protect Platform security, without
                    prior notice in urgent cases.
                  </li>
                  <li>
                    Upon account termination, payout of any remaining revenue is made
                    subject to the requirements in Sections 10 and 12, including
                    completion of Stripe Connect verification.
                  </li>
                </ul>

                
                <h3>
                  24) Applicable law and dispute resolution
                </h3>
                <ul>
                  <li>
                    These Terms and all relations arising from use of the Platform are
                    governed by <b>Bulgarian law</b>.
                  </li>
                  <li>
                    Disputes shall preferably be resolved by mutual agreement. If no
                    agreement is reached, the competent court is the relevant
                    <b>Bulgarian court</b> at the seat of ATOMICA GROUP Ltd.
                  </li>
                  <li>
                    Consumers (natural persons) may use out-of-court dispute resolution
                    under the Bulgarian Consumer Protection Act and Regulation (EU) No
                    524/2013, including the European Commission’s Online Dispute
                    Resolution platform:
                    <a
                      href="https://ec.europa.eu/consumers/odr"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      ec.europa.eu/consumers/odr
                    </a>
                    .
                  </li>
                </ul>

                
                <h3>25) Contact</h3>
                <p>
                  For questions, reports or complaints regarding these Terms, use the
                  contact form on <b>eventa.tv</b> or reach us at:
                </p>
                <ContactBox>
                  <b>ATOMICA GROUP Ltd</b>
                  <br />
                  Company ID (EIK): 205822763 | VAT: BG205822763
                  <br />
                  Bulgaria, Veliko Tarnovo, 63-b Nikola Gabrovski Street
                  <br />
                  Email: <a href="mailto:info@eventa.tv">info@eventa.tv</a>
                </ContactBox>
              </div>`,
  de: `<div >
                <p class="meta">Letzte Aktualisierung: 5. April 2026</p>

                <div class="intro">
                  Diese Nutzungsbedingungen („Bedingungen“) regeln die gesamte Nutzung
                  der Plattform Eventa.tv durch Veranstalter, Teilnehmende und Besucher.
                  Mit dem Zugriff auf und/oder der Nutzung der Plattform –
                  einschließlich Erstellung eines Kontos, Veröffentlichung oder Besuch
                  einer Veranstaltung, Kauf eines Tickets oder Produkts – erklären Sie
                  sich ausdrücklich mit den Bedingungen und allen zugehörigen
                  Richtlinien einverstanden.
                </div>

                
                <h3>1) Wer wir sind</h3>
                <p>
                  Die Plattform Eventa.tv wird betrieben von <b>ATOMICA GROUP Ltd</b>
                  , Eintragungsnummer (EIK) <b>205822763</b>, USt-IdNr.:
                  <b>BG205822763</b>, eingetragener Sitz und Geschäftsadresse: Bulgarien,
                  Weliko Tarnowo, Uliza „Nikola Gabrowski“ 63-b. Rechtsform:
                  Gesellschaft mit beschränkter Haftung (OOD) (im Folgenden „Eventa.tv“,
                  „die Plattform“, „wir“, „uns“).
                </p>

                
                <h3>2) Annahme der Bedingungen</h3>
                <p>
                  Mit Zugriff auf oder Nutzung von Eventa.tv bestätigen Sie, dass Sie
                  mindestens 18 Jahre alt sind (oder mit ordnungsgemäßer Einwilligung
                  eines gesetzlichen Vertreters handeln), befugt sind, einen bindenden
                  Vertrag abzuschließen, und diese Nutzungsbedingungen, die
                  Datenschutzerklärung sowie die Cookie-Richtlinie akzeptieren. Wenn Sie
                  nicht einverstanden sind, nutzen Sie die Plattform bitte nicht.
                </p>

                
                <h3>3) Begriffsbestimmungen</h3>
                <ul>
                  <li>
                    <b>„Plattform“ / „Eventa.tv“</b> — die Website, APIs,
                    Mobiloberflächen und Systeme der ATOMICA GROUP Ltd zur Organisation
                    und Verwaltung von Online- und Hybridveranstaltungen.
                  </li>
                  <li>
                    <b>„Veranstalter“</b> — eine natürliche oder juristische Person, die
                    über die Plattform Veranstaltungen erstellt, veröffentlicht und
                    verwaltet.
                  </li>
                  <li>
                    <b>„Teilnehmende/r“</b> — eine Person, die sich registriert, ein
                    Ticket und/oder Produkt erwirbt und/oder an einer Veranstaltung über
                    die Plattform teilnimmt.
                  </li>
                  <li>
                    <b>„Veranstaltung“</b> — eine Online- oder Hybridveranstaltung
                    (Konferenz, Webinar, Kurs usw.), die vom Veranstalter veröffentlicht
                    wird und über RTMP-Streaming, Zoom oder eine andere genehmigte
                    Integration durchgeführt wird.
                  </li>
                  <li>
                    <b>„Ticket“</b> — ein persönliches, nicht übertragbares Zugangsrecht
                    zu einer bestimmten Veranstaltung und/oder zur privaten Seite unter
                    den angegebenen Bedingungen und Einschränkungen.
                  </li>
                  <li>
                    <b>„Private Seite“</b> — ein geschützter Bereich der Plattform für
                    Teilnehmende mit gültigem Zugang mit Programm, Materialien,
                    Beitrittsbutton, digitalen Produkten, Zertifikaten usw.
                  </li>
                  <li>
                    <b>„Produkt“</b> — ein digitales Produkt oder Inhalt, das/den der
                    Veranstalter auf der privaten Seite gegen zusätzliche Vergütung
                    anbietet.
                  </li>
                  <li>
                    <b>„Add-on“</b> — zusätzliche Funktionalität oder Ressource (z. B.
                    größerer Raum/Kapazität), die der Veranstalter für eine bestimmte
                    Veranstaltung erwirbt.
                  </li>
                  <li>
                    <b>„Stripe“</b> — Zahlungsdienstleister (Stripe, Inc. / Stripe
                    Payments Europe, Ltd.), über dessen Infrastruktur Zahlungen,
                    3DS-Authentifizierung, Stripe Connect, Auszahlungen und
                    Streitigkeiten/Chargebacks abgewickelt werden.
                  </li>
                  <li>
                    <b>„Stripe-Connect-Konto“</b> — das Konto des Veranstalters, das mit
                    dem Stripe-Konto der Plattform Eventa.tv verknüpft ist und für
                    Auszahlungen erforderlich ist.
                  </li>
                  <li>
                    <b>„Provision / Plattformgebühr“</b> — Prozentsatz/fester Betrag, den
                    Eventa.tv bei jeder Transaktion gemäß der aktuellen Preisliste
                    einbehält.
                  </li>
                  <li>
                    <b>„Partnerprogramm“</b> — ein Empfehlungsschema, bei dem Dritte
                    Provision für über einen eindeutigen Empfehlungslink generierte
                    Ticketverkäufe erhalten.
                  </li>
                </ul>

                
                <h3>4) Wesen und Umfang der Leistung</h3>
                <p>
                  Eventa.tv ist eine Technologieplattform „Software as a Service“ (SaaS),
                  die Veranstaltern folgende Funktionen bereitstellt:
                </p>
                <ul>
                  <li>
                    Öffentliche Veranstaltungsseite mit Beschreibung und Anmeldung.
                  </li>
                  <li>
                    Private Seite für Teilnehmende (Materialien, Programm, Produkte,
                    Zertifikate).
                  </li>
                  <li>
                    Ticketing-Modul und Preisstufen mit integrierter Zahlung über Stripe.
                  </li>
                  <li>
                    Verkauf digitaler Produkte innerhalb der privaten Seite.
                  </li>
                  <li>
                    Live-Streaming über das RTMP-Protokoll oder Zoom-Integration.
                  </li>
                  <li>
                    Teilnehmendenverwaltung: manuelle Erfassung, CSV-Import,
                    Reservierungen.
                  </li>
                  <li>Automatisierte E-Mail-/SMS-Erinnerungen und Benachrichtigungen.</li>
                  <li>Ausstellung personalisierter Teilnahmezertifikate.</li>
                  <li>
                    Add-ons für erweiterte Kapazität (bis zu 300 / 500 / 1.000
                    Teilnehmende).
                  </li>
                  <li>Integrationen: Zapier (Automatisierungen), CSV usw.</li>
                  <li>
                    Reporting, Umsatz-Dashboard, Rechnungsstellung und Auszahlungen an
                    Veranstalter.
                  </li>
                  <li>
                    Partnerprogramm mit Empfehlungslinks und Umsatz-Dashboard.
                  </li>
                </ul>
                <p>
                  Eventa.tv garantiert keine bestimmte Anzahl an Verkäufen, Teilnahme oder
                  Umsatz für einen Veranstalter. Der Erfolg einer Veranstaltung hängt von
                  den Anstrengungen und Inhalten des Veranstalters ab.
                </p>

                
                <h3>5) Registrierung und Konten</h3>
                <ul>
                  <li>
                    Zur Erstellung von Veranstaltungen und/oder zum Kauf von
                    Tickets/Produkten ist ein Eventa.tv-Konto erforderlich.
                  </li>
                  <li>
                    Sie verpflichten sich, genaue, vollständige und aktuelle Angaben zu
                    machen und diese auf dem neuesten Stand zu halten.
                  </li>
                  <li>
                    Sie tragen die volle Verantwortung für die Vertraulichkeit Ihrer
                    Zugangsdaten (E-Mail/Passwort) und für alle Handlungen über Ihr
                    Konto.
                  </li>
                  <li>
                    Bei Verdacht auf kompromittierte Zugänge benachrichtigen Sie Eventa.tv
                    unverzüglich und ändern Sie Ihr Passwort.
                  </li>
                  <li>
                    Eventa.tv kann den Zugang bei Verstößen gegen die Bedingungen, bei
                    Verdacht auf Missbrauch, Betrug oder zum Schutz der Sicherheit der
                    Plattform einschränken, aussetzen oder beenden.
                  </li>
                </ul>

                
                <h3>
                  6) Rollen und Verantwortlichkeiten (Veranstalter – Teilnehmende –
                  Eventa.tv)
                </h3>
                <p>
                  Eventa.tv stellt technologische Infrastruktur bereit und
                  <b>ist nicht der Veranstalter</b> der Veranstaltungen, sofern nicht
                  ausdrücklich etwas anderes angegeben ist.
                </p>
                <ul>
                  <li>
                    <b>Der Veranstalter</b> trägt die volle Verantwortung für: (i) Inhalt,
                    Regeln, Programm und Qualität der Veranstaltung; (ii) Rechtmäßigkeit
                    der Durchführung (einschließlich Rechte an Materialien, Video, Audio,
                    personenbezogenen Daten der Teilnehmenden); (iii) Erfüllung der
                    gegenüber Teilnehmenden gemachten Zusagen (Materialien, Aufnahmen,
                    Boni, Zertifikate usw.); (iv) Richtigkeit der für Rechnungen und
                    Auszahlungen angegebenen Firmendaten.
                  </li>
                  <li>
                    <b>Die teilnehmende Person</b> verpflichtet sich: (i) vor dem Kauf
                    Beschreibung und Bedingungen der Veranstaltung zu prüfen; (ii) die
                    vom Veranstalter und von der Plattform festgelegten Regeln einzuhalten;
                    (iii) Inhalte der Veranstaltung nicht ohne ausdrückliche Erlaubnis
                    aufzuzeichnen, zu verbreiten oder gewerblich zu nutzen.
                  </li>
                  <li>
                    <b>Eventa.tv</b> ist für die Bereitstellung der Plattformfunktionen
                    und die Zahlungsabwicklung soweit technisch zumutbar verantwortlich,
                    garantiert jedoch keine ununterbrochene Verfügbarkeit oder ein
                    bestimmtes Geschäftsergebnis.
                  </li>
                </ul>

                
                <h3>7) Preismodelle und Gebühren</h3>
                <p>
                  Eventa.tv wendet folgende Basispreise an (aktuelle Preise sind stets auf
                  der Seite „Preise“ der Website veröffentlicht):
                </p>
                <ul>
                  <li>
                    <b>Kostenpflichtige Veranstaltung</b> — Tagesgebühr von <b>14 EUR/Tag</b>
                    zuzüglich Mindestprovision auf jeden verkauften Ticketumsatz.
                  </li>
                  <li>
                    <b>Kostenlose Veranstaltung</b> — Tagesgebühr von <b>14 EUR/Tag</b>
                    ohne zusätzliche Provision (Tickets sind kostenlos).
                  </li>
                  <li>
                    <b>Gemeinnützige Veranstaltung</b> — nach Vereinbarung; bis zu 1.000
                    Teilnehmende unter Sonderkonditionen (kontaktieren Sie uns).
                  </li>
                </ul>
                <p>
                  Kapazitäts-Add-ons für höhere Teilnehmerzahlen (pro Veranstaltung):
                </p>
                <ul>
                  <li>
                    Bis zu <b>300 Teilnehmende</b> — <b>19 EUR</b>
                  </li>
                  <li>
                    Bis zu <b>500 Teilnehmende</b> — <b>49 EUR</b>
                  </li>
                  <li>
                    Bis zu <b>1.000 Teilnehmende</b> — <b>139 EUR</b>
                  </li>
                </ul>
                <p>
                  Auf alle Gebühren von Eventa.tv kommen die Gebühren von Stripe gemäß
                  deren öffentlich bekannt gegebenen Bedingungen gesondert hinzu. Eventa.tv
                  behält sich das Recht vor, die Preisliste nach vorheriger Ankündigung zu
                  aktualisieren.
                </p>

                
                <h3>
                  8) Tickets, Gerätelimits und Zugang
                </h3>
                <ul>
                  <li>
                    Das Ticket gewährt <b>einem/einer Teilnehmenden</b> Zugang von einem
                    Gerät. Jedes Ticket ist <b>persönlich und grundsätzlich nicht
                    übertragbar</b>, sofern der Veranstalter oder die Plattform keine
                    Änderung ausdrücklich zulässt.
                  </li>
                  <li>
                    Die Plattform kann eine <b>Begrenzung verknüpfter Geräte</b>
                    anwenden — bei Aktivierung kann gleichzeitiges Beitreten von mehr als
                    einem Gerät mit demselben Ticket blockiert werden.
                  </li>
                  <li>
                    Der Zugang zur privaten Seite wird gemäß Zugangsstatus und der vom
                    Veranstalter eingestellten „sichtbar ab“-Einstellung (Datum/Uhrzeit)
                    aktiviert.
                  </li>
                  <li>
                    Die maximale Teilnehmerzahl ist durch den gewählten Tarif und die
                    gekauften Add-ons begrenzt. Der Veranstalter ist verpflichtet, vor
                    Veröffentlichung der Veranstaltung ausreichend Kapazität
                    sicherzustellen.
                  </li>
                  <li>
                    Die Dauer der Veranstaltung ist auf <b>30 Stunden</b> (gesamt) innerhalb
                    des erworbenen Tagestarifs begrenzt.
                  </li>
                </ul>

                
                <h3>9) Zahlungen</h3>
                <p>
                  Alle Zahlungsvorgänge auf der Plattform werden über <b>Stripe</b>
                  abgewickelt. Eventa.tv <b>speichert keine Kartendaten</b>; Kartendaten
                  werden direkt von Stripe gemäß PCI DSS verarbeitet.
                </p>
                <ul>
                  <li>
                    <b>Zahlungen von Teilnehmenden</b> — Kauf eines Tickets oder digitalen
                    Produkts über Stripe PaymentIntent; bei Bedarf 3DS-Authentifizierung
                    (PSD2/SCA).
                  </li>
                  <li>
                    <b>Zahlungen von Veranstaltern</b> — Gebühren für Veröffentlichung und
                    Add-ons werden über gespeicherte Zahlungskarte oder vom Veranstalter
                    in der Plattform initiierte Transaktion eingezogen.
                  </li>
                  <li>
                    <b>Zufluss der Gelder</b> — bei Ticket-/Produktkauf gehen Beträge
                    <b>zunächst auf das Stripe-Konto von Eventa.tv</b>, um ggf.
                    Rückerstattungen und Streitigkeiten/Chargebacks zu steuern.
                  </li>
                  <li>
                    Eventa.tv behält bei jeder Tickettransaktion die <b>Provision /
                    Plattformgebühr</b> (Application Fee) ein. Der Rest ist der Nettoerlös
                    des Veranstalters.
                  </li>
                  <li>
                    Die Stripe-Gebühren fallen gesondert an und sind nicht in der
                    Plattformgebühr von Eventa.tv enthalten.
                  </li>
                </ul>

                
                <h3>
                  10) Stripe Connect und Auszahlungen an den Veranstalter
                </h3>
                <ul>
                  <li>
                    Zur Auszahlung von Erlösen muss der Veranstalter ein <b>Stripe-Connect-Konto</b>
                    über die Kontoeinstellungen verknüpfen. Bei inaktivem oder unvollständig
                    verifiziertem Stripe-Connect-Konto erfolgen <b>keine Auszahlungen</b>.
                  </li>
                  <li>
                    Die Auszahlung des Nettoerlöses des Veranstalters erfolgt <b>frühestens
                    7 (sieben) Tage nach Ende</b> der Veranstaltung, sofern: (i) keine
                    aktiven Streitigkeiten/Chargebacks bestehen; (ii) keine Hinweise auf
                    Missbrauch oder Verstöße vorliegen; (iii) der Veranstalter die
                    erforderlichen Rechnungsdaten und fortlaufende Rechnungsnummer
                    bereitgestellt hat (vgl. Abschnitt 12); (iv) keine offenen Verpflichtungen
                    gegenüber der Plattform bestehen; (v) keine gesetzlichen oder technischen
                    Hindernisse bestehen.
                  </li>
                  <li>
                    Bei aktivem Streit/Chargeback kann Eventa.tv die Auszahlung vorübergehend
                    einhalten und/oder verbundene Kosten/Gebühren im gesetzlich zulässigen
                    Umfang verrechnen.
                  </li>
                  <li>
                    Der Veranstalter kann den Zahlungsstatus („Auszahlung fällig“,
                    „Zurückgehalten“, „Ausgezahlt“, „Erstattet“) im Bereich „Umsatz“ seines
                    Profils einsehen.
                  </li>
                  <li>
                    Eventa.tv kann einen Link zum Stripe Express Dashboard für
                    Transaktionsdetails bereitstellen.
                  </li>
                </ul>

                
                <h3>11) Rückerstattungen (Refund Policy)</h3>
                <HighlightBox>
                  <b>Wesentliche Regel:</b> Nach Beginn der Veranstaltung werden
                  <b>keine Rückerstattungen</b> vorgenommen. Eine Rückerstattung ist nur
                  vor Beginn der Veranstaltung möglich oder wenn die Veranstaltung
                  <b>nicht gestartet bzw. überhaupt nicht übertragen wurde</b>.
                </HighlightBox>
                <ul>
                  <li>
                    Alle Rückerstattungen laufen über Stripe. Die Bearbeitung kann je nach
                    Bank des/der Teilnehmenden 5–10 Werktage dauern.
                  </li>
                  <li>
                    Nach Beginn der Veranstaltung erfolgt <b>keine</b> Rückerstattung,
                    insbesichtlich: Nichterscheinen, technischer Probleme auf Seiten des/der
                    Teilnehmenden, fehlendem Gerät/Internet, Unzufriedenheit mit dem Programm
                    nach der Veranstaltung.
                  </li>
                  <li>
                    <b>Ausnahme:</b> wenn die Veranstaltung nicht gestartet bzw. überhaupt
                    nicht übertragen wurde (z. B. bei Absage oder Nichterfüllung durch den
                    Veranstalter). In diesen Fällen kann eine vollständige oder teilweise
                    Rückerstattung erfolgen.
                  </li>
                  <li>
                    Das gesetzliche Widerrufsrecht nach bulgarischem Verbraucherschutzrecht
                    gilt nicht für Freizeitleistungen zu einem bestimmten Zeitpunkt/Zeitraum
                    (Art. 57 Nr. 12 bulgarisches Verbraucherschutzgesetz) — wie bei Tickets
                    für fest datierte Veranstaltungen.
                  </li>
                  <li>
                    Für digitale Produkte/Inhalte, die unmittelbar nach Kauf bereitgestellt
                    werden, kann das Widerrufsrecht entfallen, wenn die teilnehmende Person
                    vor dem Download ausdrücklich zugestimmt hat (soweit gesetzlich
                    anwendbar).
                  </li>
                  <li>
                    Bei festgestelltem Missbrauch (z. B. grundloser Chargeback) behält sich
                    Eventa.tv vor, den künftigen Zugang des betreffenden Nutzers einzuschränken.
                  </li>
                </ul>

                
                <h3>12) Rechnungsstellung</h3>
                <ul>
                  <li>
                    <b>Rechnungen an Teilnehmende:</b> ATOMICA GROUP Ltd stellt eine
                    Rechnung an eine teilnehmende Person <b>nur auf ausdrückliche Anfrage</b>
                    und nach Vorlage vollständiger Rechnungsdaten (Firma, EIK, USt-IdNr.,
                    Adresse, vertretungsberechtigte Person) aus.
                  </li>
                  <li>
                    <b>Rechnungen an Veranstalter für Plattformkosten:</b> ATOMICA GROUP Ltd
                    stellt Veranstaltern Rechnungen für deren Ausgaben auf der Plattform
                    <b>nur auf ausdrückliche Anfrage</b> aus.
                  </li>
                  <li>
                    <b>Rechnung vom Veranstalter an Eventa.tv (für Auszahlung):</b> Zur
                    Auszahlung des Nettoerlöses muss der Veranstalter korrekte Firmendaten und
                    eine <b>fortlaufende Rechnungsnummer</b> angeben. Darauf kann Eventa.tv ein
                    Dokument <b>im Namen des Veranstalters</b> an ATOMICA GROUP Ltd zur
                    buchhalterischen Abwicklung der Auszahlung erzeugen.
                  </li>
                  <li>
                    Der Veranstalter trägt die <b>volle Verantwortung für die Richtigkeit</b>
                    der angegebenen Daten (EIK/USt-IdNr., Adresse, vertretungsberechtigte Person,
                    fortlaufende Nummer usw.) sowie für eigene steuerliche und buchhalterische
                    Pflichten. Eventa.tv <b>bietet keine steuerliche oder buchhalterische
                    Beratung</b>.
                  </li>
                  <li>
                    Umsatzsteuerpflichtige Veranstalter sind für korrekte Umsatzsteuerberechnung
                    und -anmeldung nach geltendem Recht verantwortlich. Eventa.tv zeigt im
                    Umsatz-Dashboard vorläufige Umsatzsteuerberechnungen nur zu Informationszwecken.
                  </li>
                </ul>

                
                <h3>13) Partnerprogramm</h3>
                <ul>
                  <li>
                    Eventa.tv bietet ein Partnerprogramm, über das Dritte einen Empfehlungslink
                    erhalten und Provision auf generierte Ticketverkäufe verdienen können.
                  </li>
                  <li>
                    Bedingungen, Prozentsätze und Auszahlungen des Partnerprogramms sind im
                    entsprechenden Bereich der Plattform beschrieben und können aktualisiert werden.
                  </li>
                  <li>
                    Auszahlungen von Partnerprovisionen unterliegen denselben Anforderungen an
                    Stripe Connect und Rechnungsstellung wie in den Abschnitten 10 und 12
                    beschrieben.
                  </li>
                  <li>
                    Künstlich erzeugte Klicks oder Transaktionen zum Missbrauch des
                    Partnerprogramms sind untersagt. Eventa.tv kann die Teilnahme bei Verdacht
                    auf Missbrauch beenden.
                  </li>
                </ul>

                
                <h3>14) Zertifikate</h3>
                <ul>
                  <li>
                    Der Veranstalter kann das Zertifikatsmodul aktivieren und personalisierte
                    Teilnahmezertifikate für seine Teilnehmenden erzeugen.
                  </li>
                  <li>
                    Der Veranstalter ist für Inhalt, Gestaltung und etwaige rechtliche oder
                    bildungsrechtliche Folgen der ausgestellten Zertifikate verantwortlich.
                    Eventa.tv stellt ausschließlich die technische Infrastruktur zur Erzeugung
                    und Bereitstellung der PDF-Dokumente bereit.
                  </li>
                </ul>

                
                <h3>15) Integrationen und Drittanbieter</h3>
                <ul>
                  <li>
                    Die Plattform integriert oder kann Dienste Dritter integrieren:
                    <b>Stripe</b> (Zahlungen), <b>Zoom</b> (Videokonferenzen),
                    <b>Zapier</b> (Automatisierungen), E-Mail- und SMS-Anbieter, RTMP-Streaming
                    usw.
                  </li>
                  <li>
                    Eventa.tv <b>übernimmt keine Haftung</b> für Ausfälle, Änderungen der
                    Bedingungen, Einschränkungen, Fehler oder Nichtverfügbarkeit von Diensten
                    Dritter, einschließlich Zoom und Zapier.
                  </li>
                  <li>
                    Bei Nutzung von Integrationen gelten auch deren Nutzungsbedingungen und
                    Datenschutzrichtlinien.
                  </li>
                  <li>
                    Der Veranstalter ist für die korrekte Konfiguration der Integrationen (z. B.
                    Zapier-Webhook-Tokens, Zoom-Links) und für Folgen fehlerhafter Einstellung
                    verantwortlich.
                  </li>
                </ul>

                
                <h3>16) Verbotene Aktivitäten und Inhalte</h3>
                <p>Bei Nutzung der Plattform ist Folgends untersagt:</p>
                <ul>
                  <li>
                    Veröffentlichung illegaler Inhalte oder Inhalte, die Urheberrechte,
                    Marken oder Persönlichkeitsrechte verletzen.
                  </li>
                  <li>
                    Betrug, Irreführung von Teilnehmenden, falsche Veranstaltungsbeschreibungen.
                  </li>
                  <li>
                    Hassrede, Belästigung, Diskriminierung oder Aufruf zu Gewalt.
                  </li>
                  <li>
                    Versuche des unbefugten Zugangs zu Systemen, Umgehung technischer
                    Schutzmaßnahmen oder Reverse Engineering der Plattform.
                  </li>
                  <li>
                    Aufzeichnung, Verbreitung oder Weiterverkauf von Veranstaltungsinhalten ohne
                    ausdrückliche schriftliche Erlaubnis des Veranstalters.
                  </li>
                  <li>
                    Verbreitung von Schadsoftware, Spam oder unerlaubten Werbenachrichten.
                  </li>
                  <li>
                    Künstliche Erzeugung von Transaktionen, Klicks oder Registrierungen.
                  </li>
                </ul>
                <p>
                  Bei Verstößen kann Eventa.tv den Zugang zum Konto und/oder zur Veranstaltung
                  unverzüglich einschränken, aussetzen oder beenden, ohne Schadenersatz zu schulden.
                </p>

                
                <h3>17) Geistiges Eigentum</h3>
                <ul>
                  <li>
                    Alle Rechte an der Plattform (Code, Design, Marken, Oberflächen,
                    Dokumentation) stehen ATOMICA GROUP Ltd oder den jeweiligen Rechteinhabern zu.
                  </li>
                  <li>
                    Durch Hochladen von Inhalten (Text, Bilder, Video, Logos usw.) gewähren Sie
                    Eventa.tv eine nicht ausschließliche, unentgeltliche Lizenz zur Nutzung
                    ausschließlich zur Erbringung der Leistung (Anzeige, technische Vorgänge,
                    Marketing der Plattform).
                  </li>
                  <li>
                    Sie garantieren, dass Sie Rechte an den hochgeladenen Inhalten haben und diese
                    keine Rechte Dritter verletzen.
                  </li>
                </ul>

                
                <h3>18) Verfügbarkeit der Leistung</h3>
                <ul>
                  <li>
                    Eventa.tv unternimmt angemessene Anstrengungen für Verfügbarkeit, die
                    Plattform kann jedoch vorübergehend wegen geplanter Wartung, Updates oder
                    außergewöhnlicher Umstände nicht erreichbar sein.
                  </li>
                  <li>
                    Eventa.tv haftet nicht für Störungen, Ausfälle oder Änderungen bei Diensten
                    Dritter (Stripe, Zoom, Internetanbieter usw.).
                  </li>
                  <li>
                    Bei geplanter Wartung mit Auswirkung auf laufende Veranstaltungen wird Eventa.tv
                    angemessene Anstrengungen zur vorherigen Benachrichtigung unternehmen.
                  </li>
                </ul>

                
                <h3>19) Haftungsbeschränkung</h3>
                <ul>
                  <li>
                    Die Leistung wird „wie besehen“ und „wie verfügbar“ erbracht. Im gesetzlich
                    zulässigen Umfang schließt Eventa.tv alle Gewährleistungen für
                    Handelsüblichkeit, Eignung für einen bestimmten Zweck oder unterbrechungsfreien
                    Betrieb aus.
                  </li>
                  <li>
                    Eventa.tv haftet nicht für: (i) indirekte, Folge- oder Strafschäden; (ii)
                    entgangenen Gewinn oder Erlös; (iii) Datenverlust; (iv) Inhalte, Handlungen
                    oder Unterlassungen von Veranstaltern oder Teilnehmenden.
                  </li>
                  <li>
                    Die Gesamthaftung von Eventa.tv gegenüber einem Veranstalter für kostenpflichtige
                    Leistungen ist auf die in den letzten <b>3 (drei) Monaten</b> für das
                    betreffende Ereignis/Konto von Eventa.tv erhaltenen Plattformgebühren begrenzt,
                    soweit anwendbares Recht dies zulässt.
                  </li>
                </ul>

                
                <h3>20) Freistellung (Indemnity)</h3>
                <p>
                  Der Veranstalter verpflichtet sich, Eventa.tv, deren Mitarbeitende,
                  Geschäftsführung und Partner von allen Ansprüchen, Schäden, Bußen, Kosten
                  (einschließlich angemessener Anwaltskosten) freizustellen, die entstehen aus:
                  (i) Inhalt und/oder Durchführung der Veranstaltung; (ii) Verletzung von Rechten
                  Dritter (Urheberrecht, Marken, personenbezogene Daten usw.); (iii)
                  Nichteinhaltung anwendbaren Rechts; (iv) Streit zwischen Teilnehmendem und
                  Veranstalter, soweit er durch Handeln oder Unterlassen des Veranstalters verursacht
                  wurde.
                </p>

                
                <h3>21) Schutz personenbezogener Daten</h3>
                <p>
                  Die Verarbeitung personenbezogener Daten erfolgt gemäß der Datenschutzerklärung
                  und Cookie-Richtlinie von Eventa.tv auf der Website. Stripe verarbeitet
                  Kartentransaktionsdaten als eigenverantwortlicher Verantwortlicher gemäß dessen
                  Datenschutzerklärung. Veranstalter, die personenbezogene Daten von Teilnehmenden
                  über die Plattform erheben, handeln als eigenverantwortliche Verantwortliche und
                  tragen die volle Verantwortung für die Rechtmäßigkeit der Verarbeitung.
                </p>

                
                <h3>22) Änderungen der Bedingungen</h3>
                <p>
                  Eventa.tv kann diese Bedingungen jederzeit aktualisieren. Änderungen werden ab
                  dem auf der Website veröffentlichten Datum wirksam. Bei wesentlichen Änderungen
                  werden wir angemessene Anstrengungen unternehmen, Sie zu informieren (z. B. per
                  E-Mail oder Hinweis in der Plattform). Die weitere Nutzung der Plattform nach
                  Inkrafttreten der Änderungen gilt als Annahme der aktualisierten Bedingungen.
                </p>

                
                <h3>23) Beendigung</h3>
                <ul>
                  <li>
                    Sie können die Nutzung jederzeit beenden, sofern keine aktiven offenen
                    Veranstaltungen, ungeklärten Zahlungen/Streitigkeiten oder gesetzlichen
                    Aufbewahrungspflichten bestehen.
                  </li>
                  <li>
                    Eventa.tv kann den Zugang bei Verstoß gegen die Bedingungen, aus rechtlichen
                    Gründen oder zum Schutz der Plattformsicherheit beenden oder einschränken,
                    in dringenden Fällen ohne vorherige Ankündigung.
                  </li>
                  <li>
                    Bei Kontobeendigung erfolgt die Auszahlung etwaiger Restbeträge unter
                    Einhaltung der Anforderungen der Abschnitte 10 und 12, einschließlich
                    abgeschlossener Stripe-Connect-Verifizierung.
                  </li>
                </ul>

                
                <h3>
                  24) Anwendbares Recht und Streitbeilegung
                </h3>
                <ul>
                  <li>
                    Für diese Bedingungen und alle aus der Nutzung der Plattform folgenden
                    Beziehungen gilt <b>bulgarisches Recht</b>.
                  </li>
                  <li>
                    Streitigkeiten werden vorrangig einvernehmlich gelöst. Bei fehlender Einigung
                    ist der zuständige <b>bulgarische Gerichtsstand</b> am Sitz der ATOMICA GROUP
                    Ltd maßgebend.
                  </li>
                  <li>
                    Verbraucher (natürliche Personen) können außergerichtliche Streitbeilegung
                    gemäß bulgarischem Verbraucherschutzrecht und Verordnung (EU) Nr. 524/2013
                    nutzen, einschließlich der Plattform der EU zur Online-Streitbeilegung:
                    <a
                      href="https://ec.europa.eu/consumers/odr"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      ec.europa.eu/consumers/odr
                    </a>
                    .
                  </li>
                </ul>

                
                <h3>25) Kontakt</h3>
                <p>
                  Bei Fragen, Hinweisen oder Beschwerden zu diesen Bedingungen nutzen Sie das
                  Kontaktformular auf <b>eventa.tv</b> oder erreichen Sie uns unter:
                </p>
                <ContactBox>
                  <b>ATOMICA GROUP Ltd</b>
                  <br />
                  EIK: 205822763 | USt-IdNr.: BG205822763
                  <br />
                  Bulgarien, Weliko Tarnowo, Uliza „Nikola Gabrowski“ 63-b
                  <br />
                  E-Mail: <a href="mailto:info@eventa.tv">info@eventa.tv</a>
                </ContactBox>
              </div>`,
  tr: `<div >
                <p class="meta">Son güncelleme: 5 Nisan 2026</p>

                <div class="intro">
                  İşbu Kullanım Koşulları („Koşullar”), düzenleyiciler, katılımcılar ve
                  ziyaretçiler tarafından Eventa.tv platformunun tüm kullanımını düzenler.
                  Platforma erişerek ve/veya kullanarak — hesap oluşturma, etkinlik yayınlama
                  veya katılma, bilet veya ürün satın alma dahil — Koşulları ve ilgili tüm
                  politikaları açıkça kabul etmiş olursunuz.
                </div>

                
                <h3>1) Biz kimiz</h3>
                <p>
                  Eventa.tv platformu <b>ATOMICA GROUP Ltd</b> tarafından işletilir;
                  sicil numarası (EIK) <b>205822763</b>, KDV kaydı: <b>BG205822763</b>,
                  tescilli merkez ve iş adresi: Bulgaristan, Veliko Tırnovo, Nikola Gabrovski
                  Sokak 63-b. Hukuki şekil: limited şirket (OOD) (bundan böyle „Eventa.tv”,
                  „Platform”, „biz”).
                </p>

                
                <h3>2) Koşulların kabulü</h3>
                <p>
                  Eventa.tv’ye erişerek veya kullanarak en az 18 yaşında olduğunuzu (veya
                  yasal temsilci uygun rızasıyla hareket ettiğinizi), bağlayıcı sözleşme
                  yapma yetkisine sahip olduğunuzu ve işbu Koşulları, Gizlilik Politikasını ve
                  Çerez Politikasını kabul ettiğinizi teyit edersiniz. Kabul etmiyorsanız
                  lütfen Platformu kullanmayın.
                </p>

                
                <h3>3) Tanımlar</h3>
                <ul>
                  <li>
                    <b>„Platform” / „Eventa.tv”</b> — çevrim içi ve hibrit etkinlikleri
                    düzenlemek ve yönetmek için ATOMICA GROUP Ltd’ye ait web sitesi, API’ler,
                    mobil arayüzler ve sistemler.
                  </li>
                  <li>
                    <b>„Düzenleyici”</b> — Platform üzerinden etkinlik oluşturan, yayınlayan
                    ve yöneten gerçek veya tüzel kişi.
                  </li>
                  <li>
                    <b>„Katılımcı”</b> — kayıt olan, bilet ve/veya ürün satın alan ve/veya
                    Platform üzerinden etkinliğe katılan kişi.
                  </li>
                  <li>
                    <b>„Etkinlik”</b> — Düzenleyici tarafından yayınlanan ve RTMP akışı,
                    Zoom veya başka onaylı entegrasyonla gerçekleştirilen çevrim içi veya hibrit
                    etkinlik (konferans, web semineri, kurs vb.).
                  </li>
                  <li>
                    <b>„Bilet”</b> — belirli bir etkinliğe ve/veya Özel Sayfaya, belirtilen
                    koşul ve kısıtlamalara tabi olarak kişiye özel ve devredilemez erişim
                    hakkı.
                  </li>
                  <li>
                    <b>„Özel Sayfa”</b> — geçerli erişimi olan katılımcılar için program,
                    materyaller, katılım düğmesi, dijital ürünler, sertifikalar vb. içeren
                    Platformun korumalı alanı.
                  </li>
                  <li>
                    <b>„Ürün”</b> — Düzenleyici tarafından Özel Sayfada ek ücret karşılığında
                    sunulan dijital ürün veya içerik.
                  </li>
                  <li>
                    <b>„Eklenti” (Add-on)</b> — belirli bir etkinlik için Düzenleyici
                    tarafından satın alınan ek işlev veya kaynak (ör. daha büyük salon/kapasite).
                  </li>
                  <li>
                    <b>„Stripe”</b> — ödemelerin, 3DS doğrulamasının, Stripe Connect’in,
                    ödemelerin ve itirazların/chargeback’lerin işlendiği altyapıyı sağlayan
                    ödeme hizmeti sağlayıcısı (Stripe, Inc. / Stripe Payments Europe, Ltd.).
                  </li>
                  <li>
                    <b>„Stripe Connect hesabı”</b> — ödemeleri almak için Eventa.tv’nin
                    platform Stripe hesabına bağlı Düzenleyici hesabı.
                  </li>
                  <li>
                    <b>„Komisyon / platform ücreti”</b> — güncel fiyat listesine göre her
                    işlemde Eventa.tv tarafından kesilen yüzde/sabit tutar.
                  </li>
                  <li>
                    <b>„Satış ortaklığı programı”</b> — üçüncü kişilerin benzersiz yönlendirme
                    bağlantısıyla oluşturulan bilet satışları için komisyon aldığı yönlendirme
                    şeması.
                  </li>
                </ul>

                
                <h3>4) Hizmetin niteliği ve kapsamı</h3>
                <p>
                  Eventa.tv, Düzenleyicilere aşağıdaki işlevleri sunan „Yazılım hizmeti olarak”
                  (SaaS) teknoloji platformudur:
                </p>
                <ul>
                  <li>
                    Açıklama ve kayıt içeren herkese açık etkinlik sayfası.
                  </li>
                  <li>
                    Katılımcılar için özel sayfa (materyaller, program, ürünler, sertifikalar).
                  </li>
                  <li>
                    Stripe ile entegre ödemeli bilet modülü ve fiyat kademeleri.
                  </li>
                  <li>
                    Özel Sayfa içinde dijital ürün satışı.
                  </li>
                  <li>
                    RTMP protokolü veya Zoom entegrasyonu ile canlı yayın.
                  </li>
                  <li>
                    Katılımcı yönetimi: manuel ekleme, CSV içe aktarma, rezervasyonlar.
                  </li>
                  <li>Otomatik e-posta/SMS hatırlatmaları ve bildirimler.</li>
                  <li>Kişiselleştirilmiş katılım sertifikalarının düzenlenmesi.</li>
                  <li>
                    Genişletilmiş kapasite eklentileri (300 / 500 / 1.000 katılımcıya kadar).
                  </li>
                  <li>Entegrasyonlar: Zapier (otomasyonlar), CSV vb.</li>
                  <li>
                    Raporlama, gelir panosu, faturalama ve düzenleyicilere ödemeler.
                  </li>
                  <li>
                    Yönlendirme bağlantıları ve gelir panosu ile satış ortaklığı programı.
                  </li>
                </ul>
                <p>
                  Eventa.tv herhangi bir düzenleyici için belirli bir satış, katılım veya gelir
                  sayısı garanti etmez. Etkinliğin başarısı Düzenleyicinin çabasına ve içeriğine
                  bağlıdır.
                </p>

                
                <h3>5) Kayıt ve hesaplar</h3>
                <ul>
                  <li>
                    Etkinlik oluşturmak ve/veya bilet/ürün satın almak için Eventa.tv hesabı
                    gereklidir.
                  </li>
                  <li>
                    Doğru, eksiksiz ve güncel bilgi vermeyi ve bunları güncel tutmayı taahhüt
                    edersiniz.
                  </li>
                  <li>
                    Kimlik bilgilerinizin (e-posta/şifre) gizliliğinden ve hesabınız üzerinden
                    yapılan tüm işlemlerden tam sorumlusunuz.
                  </li>
                  <li>
                    Yetkisiz erişimden şüphelenirseniz derhal Eventa.tv’yi bilgilendirin ve
                    şifrenizi değiştirin.
                  </li>
                  <li>
                    Eventa.tv Koşulların ihlali, kötüye kullanım veya dolandırıcılık şüphesi veya
                    Platform güvenliğinin korunması gerektiğinde erişimi kısıtlayabilir,
                    askıya alabilir veya sonlandırabilir.
                  </li>
                </ul>

                
                <h3>
                  6) Roller ve sorumluluklar (Düzenleyici – Katılımcı – Eventa.tv)
                </h3>
                <p>
                  Eventa.tv teknoloji altyapısı sağlar ve <b>etkinliklerin düzenleyicisi
                  değildir</b>, aksi açıkça belirtilmedikçe.
                </p>
                <ul>
                  <li>
                    <b>Düzenleyici</b> şunlardan tam sorumludur: (i) içerik, kurallar, program
                    ve etkinlik kalitesi; (ii) düzenlemenin yasaya uygunluğu (materyaller,
                    video, ses, katılımcıların kişisel verileri dahil); (iii) katılımcılara
                    vaat edilenlerin yerine getirilmesi (materyaller, kayıtlar, bonuslar,
                    sertifikalar vb.); (iv) faturalama ve ödemeler için verilen ticari bilgilerin
                    doğruluğu.
                  </li>
                  <li>
                    <b>Katılımcı</b> şunları taahhüt eder: (i) satın almadan önce etkinlik
                    açıklamasını ve koşullarını incelemek; (ii) Düzenleyici ve Platformca
                    belirlenen kurallara uymak; (iii) açık izin olmadan etkinlik içeriğini
                    kaydetmemek, dağıtmamak veya ticari olarak kullanmamak.
                  </li>
                  <li>
                    <b>Eventa.tv</b> platform işlevlerinin sağlanmasından ve ödemelerin
                    işlenmesinden teknik olarak makul ölçüde sorumludur; kesintisiz erişim veya
                    belirli bir ticari sonuç garanti edilmez.
                  </li>
                </ul>

                
                <h3>7) Fiyat planları ve ücretler</h3>
                <p>
                  Eventa.tv aşağıdaki temel fiyatlandırmayı uygular (güncel fiyatlar her zaman
                  web sitesindeki „Fiyatlar” sayfasında yayınlanır):
                </p>
                <ul>
                  <li>
                    <b>Ücretli etkinlik</b> — <b>gün başına 14 EUR</b> günlük ücret artı her
                    satılan bilet işlemi üzerinden asgari komisyon.
                  </li>
                  <li>
                    <b>Ücretsiz etkinlik</b> — <b>gün başına 14 EUR</b> günlük ücret, ek
                    komisyon yok (biletler ücretsizdir).
                  </li>
                  <li>
                    <b>Hayırseverlik etkinliği</b> — karşılıklı anlaşmaya göre; özel koşullarla
                    1.000 katılımcıya kadar (bizimle iletişime geçin).
                  </li>
                </ul>
                <p>
                  Daha yüksek katılımcı sayıları için kapasite eklentileri (etkinlik başına
                  add-on):
                </p>
                <ul>
                  <li>
                    <b>300 katılımcıya</b> kadar — <b>19 EUR</b>
                  </li>
                  <li>
                    <b>500 katılımcıya</b> kadar — <b>49 EUR</b>
                  </li>
                  <li>
                    <b>1.000 katılımcıya</b> kadar — <b>139 EUR</b>
                  </li>
                </ul>
                <p>
                  Eventa.tv’nin tüm ücretlerine Stripe ücretleri, Stripe’ın kamuya açıklanan
                  koşullarına göre ayrıca uygulanır. Eventa.tv fiyat listesini önceden bildirerek
                  güncelleme hakkını saklı tutar.
                </p>

                
                <h3>
                  8) Biletler, cihaz kısıtları ve erişim
                </h3>
                <ul>
                  <li>
                    Bilet <b>bir katılımcıya</b> tek bir cihazdan erişim hakkı verir. Her bilet
                    <b>kişiseldir ve ilke olarak devredilemez</b>, Düzenleyici veya Platform
                    açıkça değişikliğe izin vermedikçe.
                  </li>
                  <li>
                    Platform <b>bağlı cihaz sınırı</b> uygulayabilir — etkinleştirildiğinde
                    aynı bilet ile birden fazla cihazdan eşzamanlı katılım engellenebilir.
                  </li>
                  <li>
                    Özel Sayfaya erişim, erişim durumuna ve Düzenleyici tarafından ayarlanan
                    „şu tarihten sonra görünür” ayarına (tarih/saat) göre etkinleşir.
                  </li>
                  <li>
                    Azami katılımcı sayısı seçilen plan ve satın alınan eklentilerle sınırlıdır.
                    Düzenleyici etkinliği yayınlamadan önce yeterli kapasiteyi sağlamaktan sorumludur.
                  </li>
                  <li>
                    Etkinlik süresi satın alınan günlük plan kapsamında toplam <b>30 saat</b>
                    ile sınırlıdır.
                  </li>
                </ul>

                
                <h3>9) Ödemeler</h3>
                <p>
                  Platformdaki tüm parasal işlemler <b>Stripe</b> üzerinden işlenir. Eventa.tv
                  <b>banka kartı verilerini saklamaz</b>; kart verileri doğrudan Stripe tarafından
                  PCI DSS standardına uygun olarak işlenir.
                </p>
                <ul>
                  <li>
                    <b>Katılımcı ödemeleri</b> — bilet veya dijital ürün satın alımı Stripe
                    PaymentIntent ile işlenir; gerekirse 3DS kimlik doğrulaması (SCA) uygulanır.
                  </li>
                  <li>
                    <b>Düzenleyici ödemeleri</b> — etkinlik yayınlama ve eklenti ücretleri,
                    saklı ödeme kartı veya Düzenleyici tarafından Platformda başlatılan işlemle
                    tahsil edilir.
                  </li>
                  <li>
                    <b>Fon akışı</b> — katılımcı bilet/ürün satın aldığında tutarlar önce
                    <b>Eventa.tv’nin Stripe hesabına</b> gelir; iadeler ve itirazların/chargeback’lerin
                    yönetimi için gerektiğinde kullanılabilir.
                  </li>
                  <li>
                    Eventa.tv her bilet işleminde <b>komisyon/platform ücretini</b> (application
                    fee) keser. Kalan tutar Düzenleyicinin net geliridir.
                  </li>
                  <li>
                    Stripe ücretleri ayrıca uygulanır ve Eventa.tv platform ücretine dahil değildir.
                  </li>
                </ul>

                
                <h3>
                  10) Stripe Connect ve Düzenleyiciye ödemeler
                </h3>
                <ul>
                  <li>
                    Ödeme almak için Düzenleyici hesap ayarlarından <b>Stripe Connect hesabını</b>
                    bağlamalıdır. Stripe Connect hesabı etkin veya tam doğrulanmamışsa ödemeler
                    <b>yapılmaz</b>.
                  </li>
                  <li>
                    Düzenleyicinin net gelirinin ödenmesi etkinlik <b>bittikten en az 7 (yedi)
                    gün sonra</b> yapılır; şu koşullarda: (i) aktif itiraz/chargeback yok; (ii)
                    kötüye kullanım veya ihlal verisi yok; (iii) Düzenleyici gerekli faturalama
                    bilgilerini ve ardışık fatura numarasını sağlamıştır (bkz. Bölüm 12); (iv)
                    Platforma karşı açık yükümlülük yok; (v) yasal veya teknik engel yok.
                  </li>
                  <li>
                    Aktif itiraz/chargeback durumunda Eventa.tv ödemeyi geçici olarak
                    tutabilir ve/veya ilgili masrafları/ücretleri yasal olarak mümkün ölçüde
                    mahsup edebilir.
                  </li>
                  <li>
                    Düzenleyici ödeme durumunu („Ödenecek”, „Tutulan”, „Ödendi”, „İade edildi”)
                    profilindeki „Gelir” bölümünden takip edebilir.
                  </li>
                  <li>
                    Eventa.tv işlem ayrıntıları için Stripe Express Panosuna bağlantı sağlayabilir.
                  </li>
                </ul>

                
                <h3>11) İadeler (Refund Policy)</h3>
                <HighlightBox>
                  <b>Temel kural:</b> Etkinlik başladıktan sonra <b>iadeler yapılmaz</b>. İade
                  yalnızca etkinlik başlamadan önce veya etkinlik <b>hiç başlamamış/yayınlanmamışsa</b>
                  mümkündür.
                </HighlightBox>
                <ul>
                  <li>
                    Tüm iadeler Stripe üzerinden işlenir. İşlem katılımcının bankasına bağlı
                    olarak 5–10 iş günü sürebilir.
                  </li>
                  <li>
                    Etkinlik başladıktan sonra katılımcının gelmemesi, katılımcı kaynaklı teknik
                    sorunlar, cihaz/internet eksikliği veya etkinlik sonrası programla anlaşmazlık
                    dahil <b>iadeler yapılmaz</b>.
                  </li>
                  <li>
                    <b>İstisna:</b> etkinlik hiç başlamamış/yayınlanmamışsa (ör. Düzenleyici
                    tarafından iptal veya gerçekleştirilmemesi). Bu durumlarda tam veya kısmi iade
                    yapılabilir.
                  </li>
                  <li>
                    Belirli tarihte/dönemdeki boş zamanla ilgili hizmetler için yasal cayma hakkı
                    Bulgaristan Tüketicinin Korunması Hakkında Kanunun 57. maddesi 12. bentine göre
                    uygulanmaz — sabit tarihli etkinlik biletleri gibi.
                  </li>
                  <li>
                    Satın alma sonrası derhal sunulan dijital ürün/içerik için, indirmeden önce
                    katılımcının açık rızası verilmişse (yasada öngörüldüğü ölçüde) cayma hakkı
                    uygulanmayabilir.
                  </li>
                  <li>
                    Kötüye kullanım tespit edilirse (ör. gerekçesiz chargeback) Eventa.tv ilgili
                    kullanıcının gelecekteki erişimini kısıtlama hakkını saklı tutar.
                  </li>
                </ul>

                
                <h3>12) Faturalama</h3>
                <ul>
                  <li>
                    <b>Katılımcılara faturalar:</b> ATOMICA GROUP Ltd katılımcıya <b>yalnızca
                    açık talep üzerine</b> ve eksiksiz faturalama bilgileri (şirket, EIK, KDV
                    numarası, adres, yetkili kişi) verildiğinde fatura düzenler.
                  </li>
                  <li>
                    <b>Düzenleyicilere platform giderleri için faturalar:</b> ATOMICA GROUP Ltd
                    Düzenleyicilere Platformdaki giderleri için <b>yalnızca açık talep üzerine</b>
                    fatura düzenler.
                  </li>
                  <li>
                    <b>Düzenleyiciden Eventa.tv’ye fatura (ödeme için):</b> Net gelir ödemesi
                    almak için Düzenleyici doğru ticari bilgiler ve <b>ardışık fatura numarası</b>
                    sağlamalıdır. Buna göre Eventa.tv ödemenin muhasebesel olarak kesinleşmesi için
                    ATOMICA GROUP Ltd’ye karşı <b>Düzenleyici adına</b> belge oluşturabilir.
                  </li>
                  <li>
                    Düzenleyici verilen bilgilerin doğruluğundan (EIK/KDV numarası, adres,
                    yetkili kişi, ardışık numara vb.) ve kendi muhasebe ve vergi yükümlülüklerinden
                    <b>tam sorumludur</b>. Eventa.tv <b>muhasebe veya vergi danışmanlığı
                    sunmaz</b>.
                  </li>
                  <li>
                    KDV kayıtlı düzenleyiciler uygulanabilir mevzuata uygun doğru KDV tahakkuku ve
                    beyanından sorumludur. Eventa.tv gelir panosunda gösterilen KDV tahminleri yalnızca
                    bilgilendiricidir.
                  </li>
                </ul>

                
                <h3>13) Satış ortaklığı programı</h3>
                <ul>
                  <li>
                    Eventa.tv üçüncü kişilerin yönlendirme bağlantısı alıp bilet satışlarından
                    komisyon kazanabileceği bir satış ortaklığı programı sunar.
                  </li>
                  <li>
                    Programın koşulları, yüzdeleri ve ödemeleri Platformun ilgili bölümünde
                    açıklanır ve güncellenebilir.
                  </li>
                  <li>
                    Satış ortağı komisyon ödemeleri Bölüm 10 ve 12’de açıklanan Stripe Connect ve
                    faturalama gereksinimlerine tabidir.
                  </li>
                  <li>
                    Satış ortaklığı programını kötüye kullanmak için yapay tıklama veya işlem
                    oluşturmak yasaktır. Eventa.tv kötüye kullanım şüphesinde katılımı sonlandırabilir.
                  </li>
                </ul>

                
                <h3>14) Sertifikalar</h3>
                <ul>
                  <li>
                    Düzenleyici sertifika modülünü etkinleştirip katılımcıları için kişiselleştirilmiş
                    katılım sertifikaları oluşturabilir.
                  </li>
                  <li>
                    Düzenleyici düzenlenen sertifikaların içeriği, görünümü ve olası hukuki/eğitim
                    sonuçlarından sorumludur. Eventa.tv yalnızca PDF belgelerinin oluşturulması ve
                    teslimi için teknik altyapı sağlar.
                  </li>
                </ul>

                
                <h3>15) Entegrasyonlar ve üçüncü taraf hizmetleri</h3>
                <ul>
                  <li>
                    Platform üçüncü taraf hizmetlerini entegre eder veya edebilir: <b>Stripe</b>
                    (ödemeler), <b>Zoom</b> (video konferans), <b>Zapier</b> (otomasyonlar),
                    e-posta ve SMS sağlayıcıları, RTMP yayın platformları vb.
                  </li>
                  <li>
                    Eventa.tv üçüncü taraf hizmetlerinin kesintileri, koşullardaki değişiklikler,
                    kısıtlamalar, hatalar veya erişilemezliği için <b>sorumlu değildir</b>; Zoom ve
                    Zapier dahil.
                  </li>
                  <li>
                    Üçüncü taraf entegrasyonları kullanımda bunların kullanım şartları ve gizlilik
                    politikaları da geçerlidir.
                  </li>
                  <li>
                    Düzenleyici entegrasyonların doğru yapılandırılmasından (ör. Zapier webhook
                    jetonları, Zoom bağlantıları) ve yanlış yapılandırmanın sonuçlarından sorumludur.
                  </li>
                </ul>

                
                <h3>16) Yasak faaliyetler ve içerik</h3>
                <p>Platform kullanımında şunlar yasaktır:</p>
                <ul>
                  <li>
                    Yasadışı içerik veya telif hakkı, marka veya kişilik haklarını ihlal eden içerik
                    yayınlamak.
                  </li>
                  <li>
                    Dolandırıcılık, katılımcıları yanıltma, yanlış etkinlik tanımları.
                  </li>
                  <li>
                    Nefret söylemi, taciz, ayrımcılık veya şiddete tahrik.
                  </li>
                  <li>
                    Sistemlere yetkisiz erişim girişimleri, teknik koruma önlemlerini aşma veya
                    Platformun tersine mühendisliği.
                  </li>
                  <li>
                    Düzenleyicinin açık yazılı izni olmadan etkinlik içeriğini kaydetmek,
                    dağıtmak veya yeniden satmak.
                  </li>
                  <li>
                    Zararlı yazılım, spam veya istenmeyen ticari iletiler yaymak.
                  </li>
                  <li>
                    İşlem, tıklama veya kayıtları yapay olarak oluşturmak.
                  </li>
                </ul>
                <p>
                  İhlal halinde Eventa.tv hesaba ve/veya etkinliğe erişimi derhal kısıtlayabilir,
                  askıya alabilir veya sonlandırabilir; tazminat borcu doğmaz.
                </p>

                
                <h3>17) Fikri mülkiyet</h3>
                <ul>
                  <li>
                    Platform üzerindeki tüm haklar (kod, tasarım, markalar, arayüzler, belgeler)
                    ATOMICA GROUP Ltd veya ilgili hak sahiplerine aittir.
                  </li>
                  <li>
                    İçerik (metin, görüntü, video, logo vb.) yükleyerek Eventa.tv’ye yalnızca hizmetin
                    sunumu için (görüntüleme, teknik işlemler, Platform pazarlaması) kullanılmak üzere
                    münhasır olmayan, ücretsiz bir lisans vermiş olursunuz.
                  </li>
                  <li>
                    Yüklenen içerik üzerinde haklara sahip olduğunuzu ve üçüncü kişi haklarını
                    ihlal etmediğini garanti edersiniz.
                  </li>
                </ul>

                
                <h3>18) Hizmet kullanılabilirliği</h3>
                <ul>
                  <li>
                    Eventa.tv kullanılabilirlik için makul çaba gösterir; ancak planlı bakım,
                    güncellemeler veya mücbir sebepler nedeniyle Platform geçici olarak kullanılamayabilir.
                  </li>
                  <li>
                    Eventa.tv üçüncü taraf hizmetlerindeki (Stripe, Zoom, internet sağlayıcıları vb.)
                    arızalar, kesintiler veya değişikliklerden sorumlu değildir.
                  </li>
                  <li>
                    Aktif etkinlikleri etkileyen planlı bakım için Eventa.tv önceden bildirim için
                    makul çaba gösterir.
                  </li>
                </ul>

                
                <h3>19) Sorumluluğun sınırlandırılması</h3>
                <ul>
                  <li>
                    Hizmet „olduğu gibi” ve „mevcut olduğu şekilde” sunulur. Yasal olarak izin
                    verilen azami ölçüde Eventa.tv ticari uygunluk, belirli bir amaca uygunluk veya
                    kesintisiz işleyiş için tüm garantileri reddeder.
                  </li>
                  <li>
                    Eventa.tv şunlardan sorumlu değildir: (i) dolaylı, sonuç olarak doğan veya cezai
                    zararlar; (ii) kar veya gelir kaybı; (iii) veri kaybı; (iv) Düzenleyici veya
                    Katılımcıların içeriği, eylemleri veya ihmalleri.
                  </li>
                  <li>
                    Ücretli hizmetler için Eventa.tv’nin bir Düzenleyiciye toplam sorumluluğu,
                    ilgili etkinlik/hesap için son <b>3 (üç) ay</b> içinde Eventa.tv tarafından
                    alınan platform ücretleri tutarıyla sınırlıdır, uygulanabilir mevzuatın izin
                    verdiği ölçüde.
                  </li>
                </ul>

                
                <h3>20) Tazminat (Indemnity)</h3>
                <p>
                  Düzenleyici Eventa.tv’yi, çalışanlarını, yöneticilerini ve ortaklarını şunlardan
                  doğan tüm talepler, zararlar, para cezaları, masraflar (makul avukatlık ücretleri
                  dahil) karşısında tazmin etmeyi ve zararsız tutmayı taahhüt eder: (i) etkinliğin
                  içeriği ve/veya düzenlenmesi; (ii) üçüncü kişi haklarının ihlali (telif, marka,
                  kişisel veriler vb.); (iii) uygulanabilir mevzuata uyulmaması; (iv) Katılımcı ile
                  Düzenleyici arasındaki anlaşmazlık, Düzenleyicinin eylem veya ihmallerinden kaynaklanan
                  ölçüde.
                </p>

                
                <h3>21) Kişisel verilerin korunması</h3>
                <p>
                  Kişisel verilerin işlenmesi web sitesinde yayınlanan Eventa.tv Gizlilik Politikası
                  ve Çerez Politikasına uygun olarak yapılır. Stripe kart işlemi verilerini kendi
                  gizlilik politikasına göre bağımsız veri sorumlusu olarak işler. Platform üzerinden
                  katılımcıların kişisel verilerini toplayan düzenleyiciler bağımsız veri sorumlusu
                  olarak hareket eder ve işlemenin yasaya uygunluğundan tam sorumludur.
                </p>

                
                <h3>22) Koşullarda değişiklikler</h3>
                <p>
                  Eventa.tv işbu Koşulları her zaman güncelleyebilir. Değişiklikler web sitesinde
                  yayınlandıkları tarihte yürürlüğe girer. Önemli değişikliklerde makul çabayla
                  bilgilendirme yapılır (ör. e-posta veya Platform bildirimi). Değişiklikler yürürlüğe
                  girdikten sonra Platformun kullanılmaya devam edilmesi güncellenmiş Koşulların
                  kabulü anlamına gelir.
                </p>

                
                <h3>23) Fesih</h3>
                <ul>
                  <li>
                    Aktif bitmemiş etkinlik, açık ödeme/itiraz veya yasal veri saklama gereği
                    olmadığı sürece kullanımı istediğiniz zaman sonlandırabilirsiniz.
                  </li>
                  <li>
                    Eventa.tv Koşulların ihlali, yasal nedenler veya Platform güvenliği için erişimi
                    feshedebilir veya kısıtlayabilir; acil durumlarda önceden bildirim olmadan.
                  </li>
                  <li>
                    Hesap sonlandırıldığında olası kalan gelirin ödemesi Bölüm 10 ve 12’deki
                    gereksinimlere ve Stripe Connect doğrulamasının tamamlanmasına tabidir.
                  </li>
                </ul>

                
                <h3>
                  24) Uygulanacak hukuk ve uyuşmazlıkların çözümü
                </h3>
                <ul>
                  <li>
                    İşbu Koşullar ve Platform kullanımından doğan tüm ilişkiler için <b>Bulgaristan
                    hukuku</b> geçerlidir.
                  </li>
                  <li>
                    Uyuşmazlıklar öncelikle karşılıklı anlaşmayla çözülür. Anlaşma sağlanamazsa yetkili
                    mahkeme ATOMICA GROUP Ltd’nin merkezindeki ilgili <b>Bulgar mahkemesi</b>dir.
                  </li>
                  <li>
                    Tüketiciler (gerçek kişiler) Bulgaristan tüketici mevzuatı ve (AB) Tüzük No
                    524/2013 kapsamında dış mahkeme yollarını kullanabilir; bunlar arasında AB’nin
                    çevrim içi uyuşmazlık çözümü platformu da yer alır:
                    <a
                      href="https://ec.europa.eu/consumers/odr"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      ec.europa.eu/consumers/odr
                    </a>
                    .
                  </li>
                </ul>

                
                <h3>25) İletişim</h3>
                <p>
                  İşbu Koşullarla ilgili sorular, bildirimler veya şikayetler için <b>eventa.tv</b>
                  sitesindeki iletişim formunu kullanın veya bize şu adresten ulaşın:
                </p>
                <ContactBox>
                  <b>ATOMICA GROUP Ltd</b>
                  <br />
                  EIK: 205822763 | KDV: BG205822763
                  <br />
                  Bulgaristan, Veliko Tırnovo, Nikola Gabrovski Sokak 63-b
                  <br />
                  E-posta: <a href="mailto:info@eventa.tv">info@eventa.tv</a>
                </ContactBox>
              </div>`,
  sv: `<div >
                <p class="meta">Senast uppdaterad: 5 april 2026</p>

                <div class="intro">
                  Dessa användarvillkor („Villkoren”) reglerar all användning av plattformen
                  Eventa.tv av arrangörer, deltagare och besökare. Genom att komma åt och/eller
                  använda plattformen—inklusive att skapa konto, publicera eller delta i ett
                  evenemang, köpa biljett eller produkt—godkänner du uttryckligen Villkoren och
                  alla relaterade policyer.
                </div>

                
                <h3>1) Vilka vi är</h3>
                <p>
                  Plattformen Eventa.tv drivs av <b>ATOMICA GROUP Ltd</b>, organisationsnummer
                  (EIK) <b>205822763</b>, momsregistreringsnummer: <b>BG205822763</b>, säte och
                  adress: Bulgarien, Veliko Tarnovo, Nikola Gabrovski-gatan 63-b. Bolagsform:
                  bulgariskt handelsbolag med begränsat ansvar (OOD) (nedan „Eventa.tv”,
                  „Plattformen”, „vi”, „oss”).
                </p>

                
                <h3>2) Godkännande av villkoren</h3>
                <p>
                  Genom att komma åt eller använda Eventa.tv bekräftar du att du är minst 18 år
                  (eller agerar med lagligt ställföreträdares samtycke), har rätt att ingå bindande
                  avtal och accepterar dessa Villkor, integritetspolicyn och cookiepolicyn. Om du
                  inte godkänner dem, använd inte Plattformen.
                </p>

                
                <h3>3) Definitioner</h3>
                <ul>
                  <li>
                    <b>„Plattform” / „Eventa.tv”</b> — webbplatsen, API:er, mobilgränssnitt och
                    system som tillhör ATOMICA GROUP Ltd för att organisera och hantera online-
                    och hybridevenemang.
                  </li>
                  <li>
                    <b>„Arrangör”</b> — fysisk eller juridisk person som skapar, publicerar och
                    hanterar evenemang via Plattformen.
                  </li>
                  <li>
                    <b>„Deltagare”</b> — person som registrerar sig, köper biljett och/eller
                    produkt och/eller deltar i evenemang via Plattformen.
                  </li>
                  <li>
                    <b>„Evenemang”</b> — online- eller hybridevenemang (konferens, webinar, kurs
                    m.m.) som publiceras av en Arrangör och genomförs via RTMP-strömning, Zoom eller
                    annan godkänd integration.
                  </li>
                  <li>
                    <b>„Biljett”</b> — personlig, icke-överlåtbar rätt till tillträde till ett
                    visst evenemang och/eller den privata sidan, enligt angivna villkor och
                    begränsningar.
                  </li>
                  <li>
                    <b>„Privat sida”</b> — skyddat område på Plattformen för deltagare med giltig
                    åtkomst, med program, material, anslutningsknapp, digitala produkter,
                    certifikat m.m.
                  </li>
                  <li>
                    <b>„Produkt”</b> — digital produkt eller innehåll som Arrangören erbjuder på
                    den privata sidan mot extra avgift.
                  </li>
                  <li>
                    <b>„Tillägg” (Add-on)</b> — extra funktionalitet eller resurs (t.ex. större
                    rum/kapacitet) som Arrangören köper för ett visst evenemang.
                  </li>
                  <li>
                    <b>„Stripe”</b> — betaltjänstleverantör (Stripe, Inc. / Stripe Payments Europe,
                    Ltd.) vars infrastruktur hanterar betalningar, 3DS-autentisering, Stripe Connect,
                    utbetalningar och tvister/chargebacks.
                  </li>
                  <li>
                    <b>„Stripe Connect-konto”</b> — Arrangörens konto kopplat till Eventa.tv:s
                    plattforms-Stripe-konto, som krävs för att ta emot utbetalningar.
                  </li>
                  <li>
                    <b>„Provision / plattformsavgift”</b> — procent/fast belopp som Eventa.tv
                    behåller vid varje transaktion enligt gällande prislista.
                  </li>
                  <li>
                    <b>„Affiliateprogram”</b> — hänvisningsschema där tredje part får provision på
                    biljettförsäljning via unik hänvisningslänk.
                  </li>
                </ul>

                
                <h3>4) Tjänstens art och omfattning</h3>
                <p>
                  Eventa.tv är en teknologiplattform „Software as a Service” (SaaS) som ger
                  Arrangörer följande funktioner:
                </p>
                <ul>
                  <li>
                    Offentlig evenemangssida med beskrivning och registrering.
                  </li>
                  <li>
                    Privat sida för deltagare (material, program, produkter, certifikat).
                  </li>
                  <li>
                    Biljettmodul och prisnivåer med inbyggd betalning via Stripe.
                  </li>
                  <li>
                    Försäljning av digitala produkter inom den privata sidan.
                  </li>
                  <li>
                    Direktsändning via RTMP-protokoll eller Zoom-integration.
                  </li>
                  <li>
                    Deltagarhantering: manuellt tillägg, CSV-import, reservationer.
                  </li>
                  <li>Automatiska e-post-/SMS-påminnelser och aviseringar.</li>
                  <li>Utfärdande av personaliserade deltagarcertifikat.</li>
                  <li>
                    Tillägg för utökad kapacitet (upp till 300 / 500 / 1 000 deltagare).
                  </li>
                  <li>Integrationer: Zapier (automatisering), CSV m.m.</li>
                  <li>
                    Rapportering, intäktsinstrumentpanel, fakturering och utbetalningar till
                    arrangörer.
                  </li>
                  <li>
                    Affiliateprogram med hänvisningslänkar och intäktsinstrumentpanel.
                  </li>
                </ul>
                <p>
                  Eventa.tv garanterar inte ett visst antal försäljningar, deltagande eller intäkter
                  för någon arrangör. Ett evenemangs framgång beror på Arrangörens arbete och
                  innehåll.
                </p>

                
                <h3>5) Registrering och konton</h3>
                <ul>
                  <li>
                    För att skapa evenemang och/eller köpa biljetter/produkter krävs ett Eventa.tv-
                    konto.
                  </li>
                  <li>
                    Du åtar dig att lämna korrekta, fullständiga och aktuella uppgifter och att
                    hålla dem uppdaterade.
                  </li>
                  <li>
                    Du ansvarar fullt ut för sekretessen kring dina inloggningsuppgifter
                    (e-post/lösenord) och för alla åtgärder som vidtas via ditt konto.
                  </li>
                  <li>
                    Vid misstanke om obehörig åtkomst ska du omedelbart meddela Eventa.tv och byta
                    lösenord.
                  </li>
                  <li>
                    Eventa.tv kan begränsa, pausa eller avsluta åtkomst vid brott mot Villkoren,
                    misstanke om missbruk, bedrägeri eller vid behov av att skydda Plattformens
                    säkerhet.
                  </li>
                </ul>

                
                <h3>
                  6) Roller och ansvar (Arrangör – Deltagare – Eventa.tv)
                </h3>
                <p>
                  Eventa.tv tillhandahåller teknisk infrastruktur och <b>är inte arrangör</b> av
                  evenemangen om inte annat uttryckligen anges.
                </p>
                <ul>
                  <li>
                    <b>Arrangören</b> har fullt ansvar för: (i) innehåll, regler, program och
                    evenemangets kvalitet; (ii) laglig genomförande (inklusive rättigheter till
                    material, video, ljud, deltagarnas personuppgifter); (iii) att leverera vad som
                    lovats deltagarna (material, inspelningar, bonusar, certifikat m.m.); (iv)
                    korrektheten i företagsuppgifter för fakturering och utbetalningar.
                  </li>
                  <li>
                    <b>Deltagaren</b> åtar sig att: (i) läsa evenemangs beskrivning och villkor
                    före köp; (ii) följa regler som fastställts av Arrangören och Plattformen;
                    (iii) inte spela in, sprida eller kommersiellt utnyttja evenemangsinnehåll utan
                    uttryckligt tillstånd.
                  </li>
                  <li>
                    <b>Eventa.tv</b> ansvarar för plattformsfunktioner och betalningshantering i
                    den utsträckning som är tekniskt rimlig, men garanterar inte oavbruten
                    tillgänglighet eller visst affärsresultat.
                  </li>
                </ul>

                
                <h3>7) Prisplaner och avgifter</h3>
                <p>
                  Eventa.tv tillämpar följande grundpriser (aktuella priser publiceras alltid på
                  webbplatsens sida „Priser”):
                </p>
                <ul>
                  <li>
                    <b>Betalt evenemang</b> — dagsavgift på <b>14 EUR/dag</b> plus minsta provision
                    på varje såld biljetttransaktion.
                  </li>
                  <li>
                    <b>Gratis evenemang</b> — dagsavgift på <b>14 EUR/dag</b> utan ytterligare
                    provision (biljetterna är gratis).
                  </li>
                  <li>
                    <b>Välgörenhetsevenemang</b> — enligt överenskommelse; upp till 1 000 deltagare
                    under särskilda villkor (kontakta oss).
                  </li>
                </ul>
                <p>
                  Kapacitetstillägg för fler deltagare (per evenemang):
                </p>
                <ul>
                  <li>
                    Upp till <b>300 deltagare</b> — <b>19 EUR</b>
                  </li>
                  <li>
                    Upp till <b>500 deltagare</b> — <b>49 EUR</b>
                  </li>
                  <li>
                    Upp till <b>1 000 deltagare</b> — <b>139 EUR</b>
                  </li>
                </ul>
                <p>
                  Stripes avgifter tillkommer separat alla Eventa.tv-avgifter enligt Stripes offentligt
                  tillkännagivna villkor. Eventa.tv förbehåller sig rätten att uppdatera prislistan
                  med förhandsmeddelande.
                </p>

                
                <h3>
                  8) Biljetter, enhetsbegränsningar och åtkomst
                </h3>
                <ul>
                  <li>
                    Biljetten ger åtkomst för <b>en deltagare</b> från en enhet. Varje biljett är
                    <b>personlig och i regel icke-överlåtbar</b>, om inte Arrangören eller
                    Plattformen uttryckligen tillåter ändring.
                  </li>
                  <li>
                    Plattformen kan tillämpa en <b>begränsning av kopplade enheter</b> — vid
                    aktivering kan samtidig anslutning från mer än en enhet med samma biljett
                    blockeras.
                  </li>
                  <li>
                    Åtkomst till den privata sidan aktiveras enligt åtkomststatus och inställningen
                    „synlig efter” (datum/tid) som Arrangören anger.
                  </li>
                  <li>
                    Högsta antalet deltagare begränsas av vald plan och köpta tillägg. Arrangören
                    ansvarar för tillräcklig kapacitet innan evenemanget publiceras.
                  </li>
                  <li>
                    Evenemangets längd är begränsad till <b>30 timmar</b> (totalt) inom den köpta
                    dagsplanen.
                  </li>
                </ul>

                
                <h3>9) Betalningar</h3>
                <p>
                  Alla penningtransaktioner på Plattformen hanteras via <b>Stripe</b>. Eventa.tv
                  <b>lagrar inte kortdata</b>; kortdata behandlas direkt av Stripe enligt PCI DSS.
                </p>
                <ul>
                  <li>
                    <b>Deltagarbetalningar</b> — köp av biljett eller digital produkt hanteras via
                    Stripe PaymentIntent; vid behov tillämpas 3DS-autentisering (SCA).
                  </li>
                  <li>
                    <b>Arrangörsbetalningar</b> — avgifter för publicering och tillägg tas ut via
                    sparadt betalkort eller transaktion som Arrangören initierar i Plattformen.
                  </li>
                  <li>
                    <b>Mottagande av medel</b> — vid biljett-/produktköp av deltagare hamnar belopp
                    <b>först på Eventa.tv:s Stripe-konto</b> så att återbetalningar och tvister/
                    chargebacks kan hanteras vid behov.
                  </li>
                  <li>
                    Eventa.tv behåller <b>provisionen/plattformsavgiften</b> (application fee) vid
                    varje biljetttransaktion. Resten är Arrangörens nettointäkt.
                  </li>
                  <li>
                    Stripes avgifter debiteras separat och ingår inte i Eventa.tv:s plattformsavgift.
                  </li>
                </ul>

                
                <h3>
                  10) Stripe Connect och utbetalningar till Arrangör
                </h3>
                <ul>
                  <li>
                    För att ta emot utbetalningar måste Arrangören koppla ett <b>Stripe Connect-
                    konto</b> via kontoinställningarna. Vid inaktivt eller ofullständigt verifierat
                    Stripe Connect-konto sker <b>inga utbetalningar</b>.
                  </li>
                  <li>
                    Utbetalning av Arrangörens nettointäkt sker <b>tidigast 7 (sju) dagar efter
                    evenemangets slut</b>, förutsatt att: (i) inga aktiva tvister/chargebacks finns;
                    (ii) ingen indikation på missbruk eller överträdelser; (iii) Arrangören lämnat
                    nödvändiga faktureringsuppgifter och löpande fakturanummer (se avsnitt 12); (iv)
                    inga outstanding förpliktelser mot Plattformen; (v) inga juridiska eller tekniska
                    hinder.
                  </li>
                  <li>
                    Vid aktiv tvist/chargeback kan Eventa.tv tillfälligt hålla inne utbetalning och/
                    eller kvitta relaterade kostnader/avgifter i lagligt tillåten omfattning.
                  </li>
                  <li>
                    Arrangören kan följa betalningsstatus („Utbetalning väntar”, „Hållen”, „Utbetald”,
                    „Återbetald”) under avsnittet „Intäkter” i sin profil.
                  </li>
                  <li>
                    Eventa.tv kan tillhandahålla länk till Stripe Express Dashboard för transaktionsdetaljer.
                  </li>
                </ul>

                
                <h3>11) Återbetalningar (Refund Policy)</h3>
                <HighlightBox>
                  <b>Huvudregel:</b> Efter att evenemanget har börjat sker <b>inga återbetalningar</b>.
                  Återbetalning är möjlig endast före evenemangets start, eller om evenemanget
                  <b>inte har startats/inte sänts alls</b>.
                </HighlightBox>
                <ul>
                  <li>
                    Alla återbetalningar hanteras via Stripe. Handläggning kan ta 5–10 arbetsdagar
                    beroende på deltagarens bank.
                  </li>
                  <li>
                    Efter evenemangets start sker <b>ingen</b> återbetalning, inklusive vid: uteblivet
                    deltagande, tekniska problem hos deltagaren, brist på enhet/internet, oenighet om
                    programmet efter genomförandet.
                  </li>
                  <li>
                    <b>Undantag:</b> när evenemanget inte har startats/inte sänts alls (t.ex. vid
                    inställande eller utebliven genomförande av Arrangören). I sådana fall kan full
                    eller partiell återbetalning ske.
                  </li>
                  <li>
                    Ångerrätten enligt konsumentskydd gäller inte för fritidstjänster vid specifikt
                    datum/tidsperiod (artikel 57 punkt 12 i bulgariska konsumentskyddslagen)—som
                    biljetter till fast daterade evenemang.
                  </li>
                  <li>
                    För digitala produkter/innehåll som levereras omedelbart efter köp kan ångerrätten
                    inte gälla om deltagaren uttryckligen samtyckt före nedladdning (när tillämpligt enligt
                    lag).
                  </li>
                  <li>
                    Vid konstaterat missbruk (t.ex. chargeback utan grund) förbehåller sig Eventa.tv
                    rätten att begränsa framtida åtkomst för berörd användare.
                  </li>
                </ul>

                
                <h3>12) Fakturering</h3>
                <ul>
                  <li>
                    <b>Fakturor till deltagare:</b> ATOMICA GROUP Ltd utfärdar faktura till deltagare
                    <b>bara på uttrycklig begäran</b> och när fullständiga faktureringsuppgifter lämnats
                    (företag, EIK, momsnummer, adress, behörig person).
                  </li>
                  <li>
                    <b>Fakturor till arrangörer för plattformsutgifter:</b> ATOMICA GROUP Ltd utfärdar
                    fakturor till Arrangörer för deras utgifter på Plattformen <b>bara på uttrycklig
                    begäran</b>.
                  </li>
                  <li>
                    <b>Faktura från Arrangör till Eventa.tv (för utbetalning):</b> För att ta emot
                    utbetalning av nettointäkt måste Arrangören lämna korrekta företagsuppgifter och
                    <b>löpande fakturanummer</b>. Utifrån dessa kan Eventa.tv generera dokument <b>i
                    Arrangörens namn</b> till ATOMICA GROUP Ltd för redovisningsmässig avveckling av
                    utbetalningen.
                  </li>
                  <li>
                    Arrangören har <b>fullt ansvar för korrektheten</b> i lämnade uppgifter (EIK/
                    momsnummer, adress, behörig person, löpande nummer m.m.) och för egna redovisnings-
                    och skatteförpliktelser. Eventa.tv <b>lämnar inte bokförings- eller skatterådgivning</b>.
                  </li>
                  <li>
                    Momsregistrerade Arrangörer ansvarar för korrekt moms och deklaration enligt tillämplig
                    lag. Eventa.tv visar preliminär momsberäkning i intäktsinstrumentpanelen endast som
                    information.
                  </li>
                </ul>

                
                <h3>13) Affiliateprogram</h3>
                <ul>
                  <li>
                    Eventa.tv tillhandahåller ett affiliateprogram där tredje part kan få hänvisningslänk
                    och provision på genererad biljettförsäljning.
                  </li>
                  <li>
                    Villkor, procentsatser och utbetalningar för affiliateprogrammet beskrivs i relevant
                    avsnitt på Plattformen och kan uppdateras.
                  </li>
                  <li>
                    Utbetalning av affiliateprovision omfattas av samma krav på Stripe Connect och
                    fakturering som i avsnitt 10 och 12.
                  </li>
                  <li>
                    Konstgjord generering av klick eller transaktioner för att missbruka affiliateprogrammet
                    är förbjudet. Eventa.tv kan avsluta deltagande vid misstanke om missbruk.
                  </li>
                </ul>

                
                <h3>14) Certifikat</h3>
                <ul>
                  <li>
                    Arrangören kan aktivera certifikatmodulen och generera personaliserade deltagarcertifikat.
                  </li>
                  <li>
                    Arrangören ansvarar för innehåll, utformning och eventuella juridiska/utbildningsmässiga
                    konsekvenser av utfärdade certifikat. Eventa.tv tillhandahåller endast den tekniska
                    infrastrukturen för att generera och leverera PDF-dokument.
                  </li>
                </ul>

                
                <h3>15) Integrationer och tredjepartstjänster</h3>
                <ul>
                  <li>
                    Plattformen integrerar eller kan integrera tredjepartstjänster: <b>Stripe</b>
                    (betalningar), <b>Zoom</b> (videokonferens), <b>Zapier</b> (automatisering), e-post-
                    och SMS-leverantörer, RTMP-strömningsplattformar m.m.
                  </li>
                  <li>
                    Eventa.tv <b>ansvar inte</b> för avbrott, villkorsändringar, begränsningar, fel
                    eller otillgänglighet hos tredje part, inklusive Zoom och Zapier.
                  </li>
                  <li>
                    Vid användning av integrationer gäller även deras användarvillkor och
                    integritetspolicyer.
                  </li>
                  <li>
                    Arrangören ansvarar för korrekt konfiguration av integrationer (t.ex. Zapier
                    webhook-token, Zoom-länkar) och för konsekvenser av felaktig konfiguration.
                  </li>
                </ul>

                
                <h3>16) Förbjudna aktiviteter och innehåll</h3>
                <p>Vid användning av Plattformen är följande förbjudet:</p>
                <ul>
                  <li>
                    Publicera olagligt innehåll eller innehåll som kränker upphovsrätt, varumärken eller
                    personliga rättigheter.
                  </li>
                  <li>
                    Bedrägeri, vilseledande av deltagare, falska evenemangsbeskrivningar.
                  </li>
                  <li>
                    Hatpropaganda, trakasserier, diskriminering eller uppmaning till våld.
                  </li>
                  <li>
                    Försök till obehörig åtkomst till system, kringgående av tekniska skyddsåtgärder
                    eller reverse engineering av Plattformen.
                  </li>
                  <li>
                    Inspelning, spridning eller återförsäljning av evenemangsinnehåll utan Arrangörens
                    uttryckliga skriftliga tillstånd.
                  </li>
                  <li>
                    Spridning av skadlig kod, spam eller oönskade kommersiella meddelanden.
                  </li>
                  <li>
                    Konstgjord generering av transaktioner, klick eller registreringar.
                  </li>
                </ul>
                <p>
                  Vid överträdelse kan Eventa.tv omedelbart begränsa, pausa eller avsluta åtkomst till
                  konto och/eller evenemang utan skyldighet till ersättning.
                </p>

                
                <h3>17) Immaterialrätt</h3>
                <ul>
                  <li>
                    Alla rättigheter till Plattformen (kod, design, varumärken, gränssnitt, dokumentation)
                    tillhör ATOMICA GROUP Ltd eller respektive rättsinnehavare.
                  </li>
                  <li>
                    Genom att ladda upp innehåll (text, bilder, video, logotyper m.m.) beviljar du
                    Eventa.tv en icke-exklusiv, royaltyfri licens att använda det endast för att tillhandahålla
                    tjänsten (visning, tekniska åtgärder, marknadsföring av Plattformen).
                  </li>
                  <li>
                    Du garanterar att du äger rättigheter till uppladdat innehåll och att det inte kränker
                    tredje parts rättigheter.
                  </li>
                </ul>

                
                <h3>18) Tillgänglighet av tjänsten</h3>
                <ul>
                  <li>
                    Eventa.tv gör skäliga ansträngningar för tillgänglighet, men Plattformen kan tillfälligt
                    vara otillgänglig på grund av planerat underhåll, uppdateringar eller force majeure.
                  </li>
                  <li>
                    Eventa.tv ansvarar inte för fel, avbrott eller förändringar i tredjepartstjänster (Stripe,
                    Zoom, internetleverantörer m.m.).
                  </li>
                  <li>
                    Vid planerat underhåll som påverkar aktiva evenemang kommer Eventa.tv att göra skäliga
                    ansträngningar för förhandsinformation.
                  </li>
                </ul>

                
                <h3>19) Ansvarsbegränsning</h3>
                <ul>
                  <li>
                    Tjänsten tillhandahålls „som den är” och „som tillgänglig”. I den utsträckning som tillåts
                    enligt lag frånsäger sig Eventa.tv alla garantier om säljbarhet, lämplighet för visst
                    syfte eller oavbruten drift.
                  </li>
                  <li>
                    Eventa.tv ansvarar inte för: (i) indirekta, följd- eller straffskador; (ii) utebliven vinst
                    eller intäkt; (iii) dataförlust; (iv) innehåll, handlingar eller underlåtenheter från
                    Arrangörer eller Deltagare.
                  </li>
                  <li>
                    Eventa.tv:s samlade ansvar gentemot Arrangör för betalda tjänster är begränsat till storleken
                    på plattformsavgifter som Eventa.tv mottagit under de senaste <b>3 (tre) månaderna</b> för
                    det aktuella evenemanget/kontot, i den utsträckning tillämplig lag tillåter.
                  </li>
                </ul>

                
                <h3>20) Skadeslöshetsförklaring (Indemnity)</h3>
                <p>
                  Arrangören åtar sig att hålla Eventa.tv, dess anställda, styrelseledamöter och partners
                  skadeslösa från alla anspråk, skador, böter, kostnader (inklusive skäliga advokatarvoden)
                  som uppstår till följd av: (i) evenemangets innehåll och/eller genomförande; (ii) kränkning
                  av tredje parts rättigheter (upphovsrätt, varumärken, personuppgifter m.m.); (iii) bristande
                  efterlevnad av tillämplig lag; (iv) tvist mellan Deltagare och Arrangör, i den utsträckning
                  tvisten orsakats av Arrangörens handlingar eller underlåtenheter.
                </p>

                
                <h3>21) Skydd av personuppgifter</h3>
                <p>
                  Behandling av personuppgifter sker i enlighet med Eventa.tv:s integritetspolicy och cookiepolicy
                  som publiceras på webbplatsen. Stripe behandlar korttransaktionsdata som självständig
                  personuppgiftsansvarig enligt sin egen integritetspolicy. Arrangörer som samlar deltagares
                  personuppgifter via Plattformen agerar som självständiga personuppgiftsansvariga och har fullt
                  ansvar för laglig behandling.
                </p>

                
                <h3>22) Ändringar av Villkoren</h3>
                <p>
                  Eventa.tv kan uppdatera dessa Villkor när som helst. Ändringar träder i kraft från publiceringsdatum
                  på webbplatsen. Vid väsentliga ändringar gör vi skäliga ansträngningar att informera dig (t.ex.
                  via e-post eller meddelande i Plattformen). Fortsatt användning av Plattformen efter att ändringar
                  trätt i kraft innebär godkännande av uppdaterade Villkor.
                </p>

                
                <h3>23) Uppsägning</h3>
                <ul>
                  <li>
                    Du kan avsluta användningen när som helst, förutsatt att inga aktiva ofullbordade evenemang,
                    utestående betalningar/tvister eller lagliga krav på datalagring finns.
                  </li>
                  <li>
                    Eventa.tv kan avsluta eller begränsa åtkomst vid brott mot Villkoren, av juridiska skäl eller
                    för att skydda Plattformens säkerhet, utan förhandsmeddelande i brådskande fall.
                  </li>
                  <li>
                    Vid kontouppsägning sker utbetalning av eventuellt kvarvarande intäkt enligt kraven i avsnitt
                    10 och 12, inklusive fullbordad Stripe Connect-verifiering.
                  </li>
                </ul>

                
                <h3>
                  24) Tillämplig lag och tvistlösning
                </h3>
                <ul>
                  <li>
                    Dessa Villkor och alla relationer som härrör från användning av Plattformen regleras av
                    <b>bulgarisk lag</b>.
                  </li>
                  <li>
                    Tvister löses i första hand genom ömsesidig överenskommelse. Om överenskommelse inte nås är
                    behörig domstol relevant <b>bulgarisk domstol</b> vid ATOMICA GROUP Ltd:s säte.
                  </li>
                  <li>
                    Konsumenter (fysiska personer) kan använda utomrättsliga tvistlösningsmetoder enligt bulgarisk
                    konsumentskyddslag och förordning (EU) nr 524/2013, inklusive EU-kommissionens plattform för
                    online-tvistlösning:
                    <a
                      href="https://ec.europa.eu/consumers/odr"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      ec.europa.eu/consumers/odr
                    </a>
                    .
                  </li>
                </ul>

                
                <h3>25) Kontakt</h3>
                <p>
                  För frågor, anmälningar eller klagomål angående dessa Villkor använd kontaktformuläret på
                  <b>eventa.tv</b> eller nå oss på:
                </p>
                <ContactBox>
                  <b>ATOMICA GROUP Ltd</b>
                  <br />
                  EIK: 205822763 | Moms: BG205822763
                  <br />
                  Bulgarien, Veliko Tarnovo, Nikola Gabrovski-gatan 63-b
                  <br />
                  E-post: <a href="mailto:info@eventa.tv">info@eventa.tv</a>
                </ContactBox>
              </div>`,
}
